// WARNING: This file is auto-generated by the `build_js_schema.py` script.
// Do not edit this file directly, as your changes will be overwritten.

// It is NOT the backend GraphQL schema/introspection result.
// The GraphQL introspection snapshot lives at `assets/js/gen/backend-graphql-introspection.json`.

// This TypeScript module is the single source of truth for the application's
// shared configuration between the backend and frontend.
// It is generated as a .ts file instead of a .json file for a critical reason:
//
// TypeScript does not currently support importing a JSON file and applying a
// `const` assertion to it (e.g., `import schema from './schema.json' as const;`).
// Without `as const`, we lose the specific literal types that are essential for
// our advanced type derivations. This file solves that by embedding the schema
// as an object literal and exporting it directly with `as const`.
//
// For more context, see the relevant TypeScript issue:
// https://github.com/microsoft/TypeScript/issues/32063

export const schema = {
    forms: [
        {
            properties: {
                swarmType: 'air',
                isProject: false,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'deviceName',
                        type: 'char',
                        default: null,
                        required: false,
                    },
                    {
                        name: 'project',
                        type: 'choice',
                        required: false,
                        default: null,
                        options: [null],
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'autoZeroInterval',
                        type: 'integer',
                        default: 7200,
                        required: false,
                        minValue: 3600,
                        maxValue: 14400,
                    },
                    {
                        name: 'setPointRh',
                        step: 0.01,
                        type: 'float',
                        default: 40.0,
                        required: false,
                        minValue: 0.0,
                        maxValue: 100.0,
                    },
                    {
                        name: 'kFactor',
                        step: 0.01,
                        type: 'float',
                        default: 1.0,
                        required: false,
                        minValue: 0.001,
                        maxValue: 10.0,
                    },
                    {
                        name: 'particleType',
                        type: 'choice',
                        default: 'PM10',
                        required: false,
                        options: ['TSP', 'PM1', 'PM2p5', 'PM10'],
                    },
                    {
                        name: 'pm2p5Factor',
                        step: 0.01,
                        type: 'float',
                        default: 0.7,
                        required: false,
                        minValue: 0.01,
                        maxValue: 1.0,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'concentrationAlarms',
                                keyTemplate: 'alarm_level_{index}',
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'particleType',
                                        type: 'choice',
                                        default: 'PM1',
                                        required: false,
                                        options: ['TSP', 'PM1', 'PM2p5', 'PM10'],
                                    },
                                    {
                                        name: 'interval',
                                        type: 'choice',
                                        default: 'interval_15_minutes',
                                        required: false,
                                        options: [
                                            'interval_10_minutes',
                                            'interval_15_minutes',
                                            'interval_30_minutes',
                                            'interval_1_hour',
                                            'interval_4_hours',
                                            'interval_8_hours',
                                            'interval_24_hours',
                                        ],
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 150.0,
                                        required: false,
                                        minValue: 20,
                                        disableWithZero: true,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsTrace', 'traceSaveLevel'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                    'alarmLevels',
                ],
                returnFields: {
                    name: null,
                    deviceName: null,
                    sensor: {
                        online: null,
                        wifiPassword: null,
                        name: null,
                        hasValidSubscription: null,
                        lastContact: null,
                        batteryCharge: null,
                        batteryChargeLastUpdate: null,
                        connectedUsing: null,
                        coordinates: {
                            latitude: null,
                            longitude: null,
                        },
                        hasDataUsageInfo: null,
                        dataQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsUsed: null,
                        smsLimit: null,
                        hasPendingFirmwareUpgrade: null,
                        firmwareUpgradePercentage: null,
                        isRotating: null,
                        isRestarting: null,
                    },
                    project: null,
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    overriddenFields: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    autoZeroInterval: null,
                    setPointRh: null,
                    kFactor: null,
                    particleType: null,
                    pm2p5Factor: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    id: null,
                },
                translationPrefix: 'AIR_MEASURING_POINT',
            },
        },
        {
            properties: {
                swarmType: 'vibration',
                isProject: false,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'deviceName',
                        type: 'char',
                        default: null,
                        required: false,
                    },
                    {
                        name: 'project',
                        type: 'choice',
                        required: false,
                        default: null,
                        options: [null],
                    },
                    {
                        name: 'showAlarms',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'showExceedancesInPdf',
                        type: 'boolean',
                        default: true,
                        required: false,
                    },
                    {
                        name: 'highestNRecords',
                        type: 'integer',
                        required: true,
                        default: 0,
                        minValue: 0,
                        maxValue: 100,
                    },
                    {
                        name: 'highestReadingPerDay',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'vtopEnabled',
                        type: 'boolean',
                        default: true,
                        required: false,
                    },
                    {
                        name: 'atopEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'vectorEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'guideLine',
                        type: 'choice',
                        default: 'DIN4150_3_80Hz',
                        required: false,
                        options: [
                            'SBR_A_2010',
                            'DIN4150_3_80Hz',
                            'SBR_A_2017',
                            'DIN4150_3_315Hz',
                            'BS7385_250Hz',
                            'Circulaire86',
                            'SBR_B_2002',
                            'DIN4150_2',
                            'ISEE_250Hz',
                            'SN640312a',
                            'IN1226',
                            'ONORM_S_9020',
                            'UNE_22_381_93',
                            'SS_025211',
                            'SS_4604861',
                            'NS_8141_1_2022',
                        ],
                    },
                    {
                        name: 'buildingLevel',
                        type: 'choice',
                        default: 'lowerLevel',
                        required: false,
                        options: [
                            'foundation',
                            'lowerLevel',
                            'highestFloor',
                            'pipeline',
                            'unspecified',
                            'floorSlabs',
                            'undergroundCavities',
                            'dinFoundation',
                            'selfDefined',
                            'guidelineValues',
                            'USBM_RI8507_drywall',
                            'USBM_RI8507_plaster',
                            'OSMRE_1983',
                            'freshConcrete',
                            'structure',
                            'buildingClass1',
                            'buildingClass2',
                            'buildingClass3',
                            'buildingClass4',
                            'buildingClass5',
                            'heavyStructures',
                            'industrialAndOfficeBuildings',
                            'residentialBuildings',
                            'sensitiveBuildings',
                        ],
                    },
                    {
                        name: 'selfDefinedAlarmLine',
                        type: 'choice',
                        default: null,
                        required: false,
                        options: [null],
                    },
                    {
                        name: 'category',
                        type: 'choice',
                        default: 'CAT2',
                        required: false,
                        options: ['CAT1', 'CAT2', 'CAT3'],
                    },
                    {
                        name: 'measuringType',
                        type: 'choice',
                        default: 'indicative',
                        required: false,
                        options: ['indicative', 'limited', 'extensive'],
                    },
                    {
                        name: 'groundCondition',
                        type: 'choice',
                        default: 'soil',
                        required: false,
                        options: ['soil', 'denseMoraineAndCompactedFillOver2m', 'rock'],
                    },
                    {
                        name: 'foundationType',
                        type: 'choice',
                        default: 'foundationOnOrInSoil',
                        required: false,
                        options: ['foundationOnOrInSoil', 'foundationOnRock'],
                    },
                    {
                        name: 'sourceDistance',
                        step: 0.01,
                        type: 'float',
                        default: 5.0,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'concreteSettingLevel',
                        type: 'choice',
                        default: 'lessThan2hours',
                        required: false,
                        options: [
                            'lessThan2hours',
                            'lessThan10MPa',
                            'rc10MPaTo15MPa',
                            'moreThan15MPa',
                        ],
                    },
                    {
                        name: 'vibrationSource',
                        type: 'choice',
                        default: 'blasting',
                        required: false,
                        options: [
                            'blasting',
                            'mechanicalDevices',
                            'pilingSheetingExcavation',
                            'compaction',
                            'constructionActivities',
                            'vibratoryActivities',
                            'licensedQuarryAndMiningBlasting',
                        ],
                    },
                    {
                        name: 'vibrationType',
                        type: 'choice',
                        default: 'continuous',
                        required: false,
                        options: [
                            'continuous',
                            'repeated',
                            'shortTerm',
                            'longTerm',
                            'peak',
                            'impulsive',
                            'momentarily',
                            'continually',
                        ],
                    },
                    {
                        name: 'zetGevLaagdikte',
                        type: 'choice',
                        default: 'H_1m',
                        required: false,
                        options: ['H_1m', 'H_2m', 'H_3m', 'H_4m', 'H_5m', 'H_6m', 'H_7m', 'H_8m'],
                    },
                    {
                        name: 'buildingState',
                        type: 'choice',
                        default: 'normal',
                        required: false,
                        options: ['normal', 'sensitive'],
                    },
                    {
                        name: 'liningMaterial',
                        type: 'choice',
                        default: 'reinforcedConcreteAndTubing',
                        required: false,
                        options: [
                            'reinforcedConcreteAndTubing',
                            'concreteAndStone',
                            'masonry',
                            'materialClass1',
                            'materialClass2',
                            'materialClass3',
                            'materialClass4',
                            'reinforcedConcreteSteelWood',
                            'unreinforcedConcreteBrickEtc',
                            'aeratedConcreteAndDelicateDetails',
                        ],
                    },
                    {
                        name: 'underground',
                        type: 'choice',
                        default: 'claySiltSandGravel',
                        required: false,
                        options: ['claySiltSandGravel', 'moraine', 'mountain'],
                    },
                    {
                        name: 'pipelineType',
                        type: 'choice',
                        default: 'weldedSteel',
                        required: false,
                        options: ['weldedSteel', 'concreteAndSteel', 'brickworkAndPlastic'],
                    },
                    {
                        name: 'constructionType',
                        type: 'choice',
                        default: 'resistantConstruction',
                        required: false,
                        options: [
                            'resistantConstruction',
                            'sensitiveConstruction',
                            'verySensitiveConstruction',
                            'platformAndCatenaryPost',
                            'structureType1',
                            'structureType2',
                            'structureType3',
                            'designClass1',
                            'designClass2',
                            'designClass3',
                        ],
                    },
                    {
                        name: 'frequencyClass',
                        type: 'choice',
                        default: 'occasionally',
                        required: false,
                        options: [
                            'occasionally',
                            'often',
                            'permanent',
                            'rarely',
                            'repetitive',
                            'frequently',
                        ],
                    },
                    {
                        name: 'sensitivityClass',
                        type: 'choice',
                        default: 'veryLittle',
                        required: false,
                        options: [
                            'veryLittle',
                            'little',
                            'scNormal',
                            'elevated',
                            'sensitivityClass0',
                            'sensitivityClass1',
                            'sensitivityClass2',
                            'sensitivityClass3',
                            'sensitivityClass4',
                        ],
                    },
                    {
                        name: 'kbfSource',
                        type: 'choice',
                        default: 'infrequentShortTerm',
                        required: false,
                        options: [
                            'infrequentShortTerm',
                            'roadTraffic',
                            'railTraffic',
                            'construction',
                        ],
                    },
                    {
                        name: 'veffBuildingType',
                        type: 'choice',
                        default: 'healthcare',
                        required: false,
                        options: [
                            'healthcare',
                            'residential',
                            'officeAndEducation',
                            'meetingBuildings',
                            'criticalWorkspaces',
                            'industrial',
                            'commercial',
                            'mixed',
                        ],
                    },
                    {
                        name: 'veffCircumstance',
                        type: 'choice',
                        default: 'continuousLongTerm',
                        required: false,
                        options: [
                            'continuousLongTerm',
                            'repeatedLongTerm',
                            'continuousOrRepeatedShortTerm',
                            'incidental',
                        ],
                    },
                    {
                        name: 'veffLowerProtection',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'veffSituation',
                        type: 'choice',
                        default: 'existing',
                        required: false,
                        options: ['existing', 'new', 'changed'],
                    },
                    {
                        name: 'veffVmaxCompliedBeforeChange',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'veffDurationOfActivities',
                        type: 'choice',
                        default: 'oneDay',
                        required: false,
                        options: [
                            'oneDay',
                            'twoDays',
                            'threeDays',
                            'fourDays',
                            'fiveDays',
                            'sixToTwentySixDays',
                            'twentySevenToSeventyEightDays',
                        ],
                    },
                    {
                        name: 'veffCustomLimitDayA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitDayA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitDayA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfVibrationLevel',
                        type: 'choice',
                        default: 'level1',
                        required: false,
                        options: ['level1', 'level2', 'level3'],
                    },
                    {
                        name: 'kbfRailTraffic',
                        type: 'choice',
                        default: 'underground',
                        required: false,
                        options: ['underground', 'surfaceUrban', 'surfaceNonUrban'],
                    },
                    {
                        name: 'kbfCustomLimitDayAu',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitDayAo',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitDayAr',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAu',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAo',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAr',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'flatLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 1.0,
                        required: false,
                        minValue: 0.02,
                        maxValue: 300.0,
                    },
                    {
                        name: 'atopFlatLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 40000.0,
                        required: false,
                        minValue: 100.0,
                        maxValue: 40000.0,
                    },
                    {
                        name: 'measurementDuration',
                        type: 'integer',
                        default: 2,
                        required: false,
                        minValue: 2,
                    },
                    {
                        name: 'dataSaveLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 0.2,
                        required: false,
                        minValue: 0.1,
                    },
                    {
                        name: 'noiseSavingEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'noiseMeasurementDuration',
                        type: 'integer',
                        default: 30,
                        required: false,
                        minValue: 30,
                    },
                    {
                        name: 'vdvEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'vdvX',
                        type: 'choice',
                        default: 'BS6841_Wd',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvY',
                        type: 'choice',
                        default: 'BS6841_Wd',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvZ',
                        type: 'choice',
                        default: 'BS6841_Wb',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvPeriod',
                        type: 'integer',
                        default: 30,
                        required: false,
                        minValue: 5,
                    },
                    {
                        name: 'traceSaveLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 100.0,
                        required: false,
                        minValue: 0.1,
                    },
                    {
                        name: 'tracePreTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'tracePostTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'maxAlarms',
                                limit: 3,
                                keyTemplate: 'alarm_level_{index}',
                                showColors: true,
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0,
                                        required: false,
                                        minValue: 1,
                                        disableWithZero: true,
                                    },
                                    {
                                        name: 'smsTemplate',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                    {
                        name: 'schedule',
                        type: 'char',
                        default: {
                            sunday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            monday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            tuesday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            wednesday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            thursday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            friday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            saturday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsTrace', 'traceSaveLevel'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                ],
                returnFields: {
                    name: null,
                    deviceName: null,
                    sensor: {
                        online: null,
                        wifiPassword: null,
                        name: null,
                        hasValidSubscription: null,
                        lastContact: null,
                        batteryCharge: null,
                        batteryChargeLastUpdate: null,
                        connectedUsing: null,
                        coordinates: {
                            latitude: null,
                            longitude: null,
                        },
                        hasDataUsageInfo: null,
                        dataQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsUsed: null,
                        smsLimit: null,
                        hasPendingFirmwareUpgrade: null,
                        firmwareUpgradePercentage: null,
                        isRotating: null,
                        isRestarting: null,
                    },
                    project: null,
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    showAlarms: null,
                    showExceedancesInPdf: null,
                    highestNRecords: null,
                    highestReadingPerDay: null,
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    overriddenFields: null,
                    alarmValue: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    vtopEnabled: null,
                    atopEnabled: null,
                    vectorEnabled: null,
                    guideLine: null,
                    buildingLevel: null,
                    selfDefinedAlarmLine: null,
                    category: null,
                    measuringType: null,
                    groundCondition: null,
                    foundationType: null,
                    sourceDistance: null,
                    concreteSettingLevel: null,
                    vibrationSource: null,
                    vibrationType: null,
                    zetGevLaagdikte: null,
                    buildingState: null,
                    liningMaterial: null,
                    underground: null,
                    pipelineType: null,
                    constructionType: null,
                    frequencyClass: null,
                    sensitivityClass: null,
                    kbfSource: null,
                    veffBuildingType: null,
                    veffCircumstance: null,
                    veffLowerProtection: null,
                    veffSituation: null,
                    veffVmaxCompliedBeforeChange: null,
                    veffDurationOfActivities: null,
                    veffCustomLimitDayA1: null,
                    veffCustomLimitDayA2: null,
                    veffCustomLimitDayA3: null,
                    veffCustomLimitEveningA1: null,
                    veffCustomLimitEveningA2: null,
                    veffCustomLimitEveningA3: null,
                    veffCustomLimitNightA1: null,
                    veffCustomLimitNightA2: null,
                    veffCustomLimitNightA3: null,
                    kbfVibrationLevel: null,
                    kbfRailTraffic: null,
                    kbfCustomLimitDayAu: null,
                    kbfCustomLimitDayAo: null,
                    kbfCustomLimitDayAr: null,
                    kbfCustomLimitNightAu: null,
                    kbfCustomLimitNightAo: null,
                    kbfCustomLimitNightAr: null,
                    flatLevel: null,
                    atopFlatLevel: null,
                    measurementDuration: null,
                    dataSaveLevel: null,
                    noiseSavingEnabled: null,
                    noiseMeasurementDuration: null,
                    vdvEnabled: null,
                    vdvX: null,
                    vdvY: null,
                    vdvZ: null,
                    vdvPeriod: null,
                    traceSaveLevel: null,
                    tracePreTrigger: null,
                    tracePostTrigger: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    schedule: {
                        sunday: {
                            enable: null,
                            disable: null,
                        },
                        monday: {
                            enable: null,
                            disable: null,
                        },
                        tuesday: {
                            enable: null,
                            disable: null,
                        },
                        wednesday: {
                            enable: null,
                            disable: null,
                        },
                        thursday: {
                            enable: null,
                            disable: null,
                        },
                        friday: {
                            enable: null,
                            disable: null,
                        },
                        saturday: {
                            enable: null,
                            disable: null,
                        },
                    },
                    id: null,
                },
                translationPrefix: 'VIBRATION_MEASURING_POINT',
            },
        },
        {
            properties: {
                swarmType: 'sound',
                isProject: false,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'deviceName',
                        type: 'char',
                        default: null,
                        required: false,
                    },
                    {
                        name: 'project',
                        type: 'choice',
                        required: false,
                        default: null,
                        options: [null],
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'externalApiTarget',
                        type: 'choice',
                        default: 'noExternalApi',
                        required: false,
                        options: ['noExternalApi', 'newYorkApi'],
                    },
                    {
                        name: 'soundGuideline',
                        type: 'choice',
                        default: 'IEC_61672',
                        required: false,
                        options: ['IEC_61672'],
                    },
                    {
                        name: 'frequencyWeighting',
                        type: 'choice',
                        default: 'frequencyWeightingA',
                        required: false,
                        options: [
                            'frequencyWeightingA',
                            'frequencyWeightingB',
                            'frequencyWeightingC',
                            'frequencyWeightingZ',
                        ],
                    },
                    {
                        name: 'timeWeighting',
                        type: 'choice',
                        default: 'timeWeightingFast',
                        required: false,
                        options: ['timeWeightingFast', 'timeWeightingSlow'],
                    },
                    {
                        name: 'lxEqInterval',
                        type: 'choice',
                        default: 'interval1Minute',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lXtMinMaxInterval',
                        type: 'choice',
                        default: 'interval1Minute',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lxPeakInterval',
                        type: 'choice',
                        default: 'intervalDisabled',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lXnInterval',
                        type: 'choice',
                        default: 'interval20Minutes',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'soundMeasurementCorrectionOption',
                        type: 'choice',
                        default: 'noCorrection',
                        required: false,
                        options: ['noCorrection', 'facade', 'music', 'impulse', 'custom'],
                    },
                    {
                        name: 'soundMeasurementCorrectionValue',
                        step: 0.01,
                        type: 'float',
                        default: 0.0,
                        required: false,
                    },
                    {
                        name: 'measuringSchedule',
                        type: 'choice',
                        default: 'entireDay',
                        required: false,
                        options: ['entireDay', 'ldenTimeSettings', 'legacySettings'],
                    },
                    {
                        name: 'soundClipAlarmSource',
                        type: 'choice',
                        default: 'disabled',
                        required: false,
                        options: ['disabled', 'leq', 'lmax', 'lpeak'],
                    },
                    {
                        name: 'traceSaveLevel',
                        step: 0.01,
                        type: 'float',
                        default: 100.0,
                        required: false,
                        minValue: 50,
                        maxValue: 140,
                    },
                    {
                        name: 'tracePreTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'tracePostTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'dailyValueSettings',
                        type: 'char',
                        required: false,
                        default: {
                            triggers: [],
                            timeSettings: {
                                start: '00:00',
                                end: '23:59',
                            },
                        },
                    },
                    {
                        name: 'ldenGuideline',
                        type: 'choice',
                        required: true,
                        default: 'LdenGuidelineNone',
                        options: [
                            'LdenGuidelineNone',
                            'LdenGuidelineDutch',
                            'LdenGuidelineUK',
                            'LdenGuidelineUK2',
                            'LdenGuidelineCustom',
                        ],
                        minValue: -2147483648,
                        maxValue: 2147483647,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'maxAlarms',
                                limit: 3,
                                keyTemplate: 'alarm_level_{index}',
                                showColors: true,
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0.0,
                                        required: false,
                                        minValue: 50,
                                        maxValue: 140,
                                    },
                                    {
                                        name: 'smsTemplate',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                ],
                            },
                            {
                                name: 'leqAlarms',
                                limit: 4,
                                keyTemplate: 'leq_alarm_{index}',
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'interval',
                                        type: 'choice',
                                        default: 'interval_15_minutes',
                                        required: false,
                                        options: [
                                            'interval_10_minutes',
                                            'interval_15_minutes',
                                            'interval_30_minutes',
                                            'interval_1_hour',
                                            'interval_4_hours',
                                            'interval_8_hours',
                                            'interval_24_hours',
                                        ],
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0.0,
                                        required: false,
                                        minValue: 50,
                                        maxValue: 140,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                    'externalApiTarget',
                ],
                returnFields: {
                    name: null,
                    deviceName: null,
                    sensor: {
                        online: null,
                        wifiPassword: null,
                        name: null,
                        hasValidSubscription: null,
                        lastContact: null,
                        batteryCharge: null,
                        batteryChargeLastUpdate: null,
                        connectedUsing: null,
                        coordinates: {
                            latitude: null,
                            longitude: null,
                        },
                        hasDataUsageInfo: null,
                        dataQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsQuota: {
                            percent: null,
                            isWarning: null,
                            isLimit: null,
                        },
                        smsUsed: null,
                        smsLimit: null,
                        hasPendingFirmwareUpgrade: null,
                        firmwareUpgradePercentage: null,
                        isRotating: null,
                        isRestarting: null,
                    },
                    project: null,
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    overriddenFields: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    externalApiTarget: null,
                    soundGuideline: null,
                    frequencyWeighting: null,
                    timeWeighting: null,
                    lxEqInterval: null,
                    lXtMinMaxInterval: null,
                    lxPeakInterval: null,
                    lXnInterval: null,
                    soundMeasurementCorrectionOption: null,
                    soundMeasurementCorrectionValue: null,
                    measuringSchedule: null,
                    soundClipAlarmSource: null,
                    traceSaveLevel: null,
                    tracePreTrigger: null,
                    tracePostTrigger: null,
                    dailyValueSettings: {
                        timeSettings: {
                            start: null,
                            end: null,
                        },
                        triggers: {
                            trigger: null,
                            days: null,
                        },
                    },
                    ldenGuideline: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    id: null,
                },
                translationPrefix: 'SOUND_MEASURING_POINT',
            },
        },
        {
            properties: {
                swarmType: 'air',
                isProject: true,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'autoZeroInterval',
                        type: 'integer',
                        default: 7200,
                        required: false,
                        minValue: 3600,
                        maxValue: 14400,
                    },
                    {
                        name: 'setPointRh',
                        step: 0.01,
                        type: 'float',
                        default: 40.0,
                        required: false,
                        minValue: 0.0,
                        maxValue: 100.0,
                    },
                    {
                        name: 'kFactor',
                        step: 0.01,
                        type: 'float',
                        default: 1.0,
                        required: false,
                        minValue: 0.001,
                        maxValue: 10.0,
                    },
                    {
                        name: 'particleType',
                        type: 'choice',
                        default: 'PM10',
                        required: false,
                        options: ['TSP', 'PM1', 'PM2p5', 'PM10'],
                    },
                    {
                        name: 'pm2p5Factor',
                        step: 0.01,
                        type: 'float',
                        default: 0.7,
                        required: false,
                        minValue: 0.01,
                        maxValue: 1.0,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'concentrationAlarms',
                                keyTemplate: 'alarm_level_{index}',
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'particleType',
                                        type: 'choice',
                                        default: 'PM1',
                                        required: false,
                                        options: ['TSP', 'PM1', 'PM2p5', 'PM10'],
                                    },
                                    {
                                        name: 'interval',
                                        type: 'choice',
                                        default: 'interval_15_minutes',
                                        required: false,
                                        options: [
                                            'interval_10_minutes',
                                            'interval_15_minutes',
                                            'interval_30_minutes',
                                            'interval_1_hour',
                                            'interval_4_hours',
                                            'interval_8_hours',
                                            'interval_24_hours',
                                        ],
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 150.0,
                                        required: false,
                                        minValue: 20,
                                        disableWithZero: true,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsTrace', 'traceSaveLevel'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                    'alarmLevels',
                ],
                returnFields: {
                    name: null,
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    autoZeroInterval: null,
                    setPointRh: null,
                    kFactor: null,
                    particleType: null,
                    pm2p5Factor: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    id: null,
                },
                translationPrefix: 'AIR_PROJECT',
            },
        },
        {
            properties: {
                swarmType: 'vibration',
                isProject: true,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'showAlarms',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'showExceedancesInPdf',
                        type: 'boolean',
                        default: true,
                        required: false,
                    },
                    {
                        name: 'highestNRecords',
                        type: 'integer',
                        required: true,
                        default: 0,
                        minValue: 0,
                        maxValue: 100,
                    },
                    {
                        name: 'highestReadingPerDay',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'vtopEnabled',
                        type: 'boolean',
                        default: true,
                        required: false,
                    },
                    {
                        name: 'atopEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'vectorEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'guideLine',
                        type: 'choice',
                        default: 'DIN4150_3_80Hz',
                        required: false,
                        options: [
                            'SBR_A_2010',
                            'DIN4150_3_80Hz',
                            'SBR_A_2017',
                            'DIN4150_3_315Hz',
                            'BS7385_250Hz',
                            'Circulaire86',
                            'SBR_B_2002',
                            'DIN4150_2',
                            'ISEE_250Hz',
                            'SN640312a',
                            'IN1226',
                            'ONORM_S_9020',
                            'UNE_22_381_93',
                            'SS_025211',
                            'SS_4604861',
                            'NS_8141_1_2022',
                        ],
                    },
                    {
                        name: 'buildingLevel',
                        type: 'choice',
                        default: 'lowerLevel',
                        required: false,
                        options: [
                            'foundation',
                            'lowerLevel',
                            'highestFloor',
                            'pipeline',
                            'unspecified',
                            'floorSlabs',
                            'undergroundCavities',
                            'dinFoundation',
                            'selfDefined',
                            'guidelineValues',
                            'USBM_RI8507_drywall',
                            'USBM_RI8507_plaster',
                            'OSMRE_1983',
                            'freshConcrete',
                            'structure',
                            'buildingClass1',
                            'buildingClass2',
                            'buildingClass3',
                            'buildingClass4',
                            'buildingClass5',
                            'heavyStructures',
                            'industrialAndOfficeBuildings',
                            'residentialBuildings',
                            'sensitiveBuildings',
                        ],
                    },
                    {
                        name: 'selfDefinedAlarmLine',
                        type: 'choice',
                        default: null,
                        required: false,
                        options: [null],
                    },
                    {
                        name: 'category',
                        type: 'choice',
                        default: 'CAT2',
                        required: false,
                        options: ['CAT1', 'CAT2', 'CAT3'],
                    },
                    {
                        name: 'measuringType',
                        type: 'choice',
                        default: 'indicative',
                        required: false,
                        options: ['indicative', 'limited', 'extensive'],
                    },
                    {
                        name: 'groundCondition',
                        type: 'choice',
                        default: 'soil',
                        required: false,
                        options: ['soil', 'denseMoraineAndCompactedFillOver2m', 'rock'],
                    },
                    {
                        name: 'foundationType',
                        type: 'choice',
                        default: 'foundationOnOrInSoil',
                        required: false,
                        options: ['foundationOnOrInSoil', 'foundationOnRock'],
                    },
                    {
                        name: 'sourceDistance',
                        step: 0.01,
                        type: 'float',
                        default: 5.0,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'concreteSettingLevel',
                        type: 'choice',
                        default: 'lessThan2hours',
                        required: false,
                        options: [
                            'lessThan2hours',
                            'lessThan10MPa',
                            'rc10MPaTo15MPa',
                            'moreThan15MPa',
                        ],
                    },
                    {
                        name: 'vibrationSource',
                        type: 'choice',
                        default: 'blasting',
                        required: false,
                        options: [
                            'blasting',
                            'mechanicalDevices',
                            'pilingSheetingExcavation',
                            'compaction',
                            'constructionActivities',
                            'vibratoryActivities',
                            'licensedQuarryAndMiningBlasting',
                        ],
                    },
                    {
                        name: 'vibrationType',
                        type: 'choice',
                        default: 'continuous',
                        required: false,
                        options: [
                            'continuous',
                            'repeated',
                            'shortTerm',
                            'longTerm',
                            'peak',
                            'impulsive',
                            'momentarily',
                            'continually',
                        ],
                    },
                    {
                        name: 'zetGevLaagdikte',
                        type: 'choice',
                        default: 'H_1m',
                        required: false,
                        options: ['H_1m', 'H_2m', 'H_3m', 'H_4m', 'H_5m', 'H_6m', 'H_7m', 'H_8m'],
                    },
                    {
                        name: 'buildingState',
                        type: 'choice',
                        default: 'normal',
                        required: false,
                        options: ['normal', 'sensitive'],
                    },
                    {
                        name: 'liningMaterial',
                        type: 'choice',
                        default: 'reinforcedConcreteAndTubing',
                        required: false,
                        options: [
                            'reinforcedConcreteAndTubing',
                            'concreteAndStone',
                            'masonry',
                            'materialClass1',
                            'materialClass2',
                            'materialClass3',
                            'materialClass4',
                            'reinforcedConcreteSteelWood',
                            'unreinforcedConcreteBrickEtc',
                            'aeratedConcreteAndDelicateDetails',
                        ],
                    },
                    {
                        name: 'underground',
                        type: 'choice',
                        default: 'claySiltSandGravel',
                        required: false,
                        options: ['claySiltSandGravel', 'moraine', 'mountain'],
                    },
                    {
                        name: 'pipelineType',
                        type: 'choice',
                        default: 'weldedSteel',
                        required: false,
                        options: ['weldedSteel', 'concreteAndSteel', 'brickworkAndPlastic'],
                    },
                    {
                        name: 'constructionType',
                        type: 'choice',
                        default: 'resistantConstruction',
                        required: false,
                        options: [
                            'resistantConstruction',
                            'sensitiveConstruction',
                            'verySensitiveConstruction',
                            'platformAndCatenaryPost',
                            'structureType1',
                            'structureType2',
                            'structureType3',
                            'designClass1',
                            'designClass2',
                            'designClass3',
                        ],
                    },
                    {
                        name: 'frequencyClass',
                        type: 'choice',
                        default: 'occasionally',
                        required: false,
                        options: [
                            'occasionally',
                            'often',
                            'permanent',
                            'rarely',
                            'repetitive',
                            'frequently',
                        ],
                    },
                    {
                        name: 'sensitivityClass',
                        type: 'choice',
                        default: 'veryLittle',
                        required: false,
                        options: [
                            'veryLittle',
                            'little',
                            'scNormal',
                            'elevated',
                            'sensitivityClass0',
                            'sensitivityClass1',
                            'sensitivityClass2',
                            'sensitivityClass3',
                            'sensitivityClass4',
                        ],
                    },
                    {
                        name: 'kbfSource',
                        type: 'choice',
                        default: 'infrequentShortTerm',
                        required: false,
                        options: [
                            'infrequentShortTerm',
                            'roadTraffic',
                            'railTraffic',
                            'construction',
                        ],
                    },
                    {
                        name: 'veffBuildingType',
                        type: 'choice',
                        default: 'healthcare',
                        required: false,
                        options: [
                            'healthcare',
                            'residential',
                            'officeAndEducation',
                            'meetingBuildings',
                            'criticalWorkspaces',
                            'industrial',
                            'commercial',
                            'mixed',
                        ],
                    },
                    {
                        name: 'veffCircumstance',
                        type: 'choice',
                        default: 'continuousLongTerm',
                        required: false,
                        options: [
                            'continuousLongTerm',
                            'repeatedLongTerm',
                            'continuousOrRepeatedShortTerm',
                            'incidental',
                        ],
                    },
                    {
                        name: 'veffLowerProtection',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'veffSituation',
                        type: 'choice',
                        default: 'existing',
                        required: false,
                        options: ['existing', 'new', 'changed'],
                    },
                    {
                        name: 'veffVmaxCompliedBeforeChange',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'veffDurationOfActivities',
                        type: 'choice',
                        default: 'oneDay',
                        required: false,
                        options: [
                            'oneDay',
                            'twoDays',
                            'threeDays',
                            'fourDays',
                            'fiveDays',
                            'sixToTwentySixDays',
                            'twentySevenToSeventyEightDays',
                        ],
                    },
                    {
                        name: 'veffCustomLimitDayA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitDayA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitDayA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitEveningA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA1',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA2',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'veffCustomLimitNightA3',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfVibrationLevel',
                        type: 'choice',
                        default: 'level1',
                        required: false,
                        options: ['level1', 'level2', 'level3'],
                    },
                    {
                        name: 'kbfRailTraffic',
                        type: 'choice',
                        default: 'underground',
                        required: false,
                        options: ['underground', 'surfaceUrban', 'surfaceNonUrban'],
                    },
                    {
                        name: 'kbfCustomLimitDayAu',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitDayAo',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitDayAr',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAu',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAo',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'kbfCustomLimitNightAr',
                        step: 0.01,
                        type: 'float',
                        default: 0.1,
                        required: false,
                    },
                    {
                        name: 'flatLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 1.0,
                        required: false,
                        minValue: 0.02,
                        maxValue: 300.0,
                    },
                    {
                        name: 'atopFlatLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 40000.0,
                        required: false,
                        minValue: 100.0,
                        maxValue: 40000.0,
                    },
                    {
                        name: 'measurementDuration',
                        type: 'integer',
                        default: 2,
                        required: false,
                        minValue: 2,
                    },
                    {
                        name: 'dataSaveLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 0.2,
                        required: false,
                        minValue: 0.1,
                    },
                    {
                        name: 'noiseSavingEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'noiseMeasurementDuration',
                        type: 'integer',
                        default: 30,
                        required: false,
                        minValue: 30,
                    },
                    {
                        name: 'vdvEnabled',
                        type: 'boolean',
                        default: false,
                        required: false,
                    },
                    {
                        name: 'vdvX',
                        type: 'choice',
                        default: 'BS6841_Wd',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvY',
                        type: 'choice',
                        default: 'BS6841_Wd',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvZ',
                        type: 'choice',
                        default: 'BS6841_Wb',
                        required: false,
                        options: [
                            'ISO2631_Wc',
                            'ISO2631_Wd',
                            'ISO2631_We',
                            'ISO2631_Wf',
                            'ISO2631_Wj',
                            'ISO2631_Wk',
                            'ISO2631_Wm',
                            'BS6841_Wb',
                            'BS6841_Wc',
                            'BS6841_Wd',
                            'BS6841_We',
                            'BS6841_Wf',
                            'BS6841_Wg',
                            'ISO5349_Wh',
                            'ISO8041_Wh',
                        ],
                    },
                    {
                        name: 'vdvPeriod',
                        type: 'integer',
                        default: 30,
                        required: false,
                        minValue: 5,
                    },
                    {
                        name: 'traceSaveLevel',
                        step: 0.01,
                        unitConversion: 'mm_to_user',
                        type: 'float',
                        default: 100.0,
                        required: false,
                        minValue: 0.1,
                    },
                    {
                        name: 'tracePreTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'tracePostTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'maxAlarms',
                                limit: 3,
                                keyTemplate: 'alarm_level_{index}',
                                showColors: true,
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0,
                                        required: false,
                                        minValue: 1,
                                        disableWithZero: true,
                                    },
                                    {
                                        name: 'smsTemplate',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                    {
                        name: 'schedule',
                        type: 'char',
                        default: {
                            sunday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            monday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            tuesday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            wednesday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            thursday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            friday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                            saturday: {
                                enable: '00:00',
                                disable: '23:59',
                            },
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsTrace', 'traceSaveLevel'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                ],
                returnFields: {
                    name: null,
                    showAlarms: null,
                    showExceedancesInPdf: null,
                    highestNRecords: null,
                    highestReadingPerDay: null,
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    alarmValue: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    vtopEnabled: null,
                    atopEnabled: null,
                    vectorEnabled: null,
                    guideLine: null,
                    buildingLevel: null,
                    selfDefinedAlarmLine: null,
                    category: null,
                    measuringType: null,
                    groundCondition: null,
                    foundationType: null,
                    sourceDistance: null,
                    concreteSettingLevel: null,
                    vibrationSource: null,
                    vibrationType: null,
                    zetGevLaagdikte: null,
                    buildingState: null,
                    liningMaterial: null,
                    underground: null,
                    pipelineType: null,
                    constructionType: null,
                    frequencyClass: null,
                    sensitivityClass: null,
                    kbfSource: null,
                    veffBuildingType: null,
                    veffCircumstance: null,
                    veffLowerProtection: null,
                    veffSituation: null,
                    veffVmaxCompliedBeforeChange: null,
                    veffDurationOfActivities: null,
                    veffCustomLimitDayA1: null,
                    veffCustomLimitDayA2: null,
                    veffCustomLimitDayA3: null,
                    veffCustomLimitEveningA1: null,
                    veffCustomLimitEveningA2: null,
                    veffCustomLimitEveningA3: null,
                    veffCustomLimitNightA1: null,
                    veffCustomLimitNightA2: null,
                    veffCustomLimitNightA3: null,
                    kbfVibrationLevel: null,
                    kbfRailTraffic: null,
                    kbfCustomLimitDayAu: null,
                    kbfCustomLimitDayAo: null,
                    kbfCustomLimitDayAr: null,
                    kbfCustomLimitNightAu: null,
                    kbfCustomLimitNightAo: null,
                    kbfCustomLimitNightAr: null,
                    flatLevel: null,
                    atopFlatLevel: null,
                    measurementDuration: null,
                    dataSaveLevel: null,
                    noiseSavingEnabled: null,
                    noiseMeasurementDuration: null,
                    vdvEnabled: null,
                    vdvX: null,
                    vdvY: null,
                    vdvZ: null,
                    vdvPeriod: null,
                    traceSaveLevel: null,
                    tracePreTrigger: null,
                    tracePostTrigger: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    schedule: {
                        sunday: {
                            enable: null,
                            disable: null,
                        },
                        monday: {
                            enable: null,
                            disable: null,
                        },
                        tuesday: {
                            enable: null,
                            disable: null,
                        },
                        wednesday: {
                            enable: null,
                            disable: null,
                        },
                        thursday: {
                            enable: null,
                            disable: null,
                        },
                        friday: {
                            enable: null,
                            disable: null,
                        },
                        saturday: {
                            enable: null,
                            disable: null,
                        },
                    },
                    id: null,
                },
                translationPrefix: 'VIBRATION_PROJECT',
            },
        },
        {
            properties: {
                swarmType: 'sound',
                isProject: true,
            },
            schema: {
                fields: [
                    {
                        name: 'name',
                        type: 'char',
                        required: true,
                        default: null,
                        maxLength: 100,
                    },
                    {
                        name: 'location',
                        type: 'char',
                        required: false,
                        default: null,
                        maxLength: 200,
                    },
                    {
                        name: 'privateNotes',
                        type: 'markdown',
                        required: false,
                        strip: false,
                        default: '',
                    },
                    {
                        name: 'disableLed',
                        type: 'boolean',
                        invertedOnOffChoices: true,
                        default: false,
                        required: false,
                    },
                    {
                        name: 'logFlushInterval',
                        type: 'integer',
                        default: 3600,
                        required: false,
                        minValue: 1,
                    },
                    {
                        name: 'timezone',
                        default: null,
                        type: 'choice',
                        required: false,
                    },
                    {
                        name: 'soundGuideline',
                        type: 'choice',
                        default: 'IEC_61672',
                        required: false,
                        options: ['IEC_61672'],
                    },
                    {
                        name: 'frequencyWeighting',
                        type: 'choice',
                        default: 'frequencyWeightingA',
                        required: false,
                        options: [
                            'frequencyWeightingA',
                            'frequencyWeightingB',
                            'frequencyWeightingC',
                            'frequencyWeightingZ',
                        ],
                    },
                    {
                        name: 'timeWeighting',
                        type: 'choice',
                        default: 'timeWeightingFast',
                        required: false,
                        options: ['timeWeightingFast', 'timeWeightingSlow'],
                    },
                    {
                        name: 'lxEqInterval',
                        type: 'choice',
                        default: 'interval1Minute',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lXtMinMaxInterval',
                        type: 'choice',
                        default: 'interval1Minute',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lxPeakInterval',
                        type: 'choice',
                        default: 'intervalDisabled',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'lXnInterval',
                        type: 'choice',
                        default: 'interval20Minutes',
                        required: false,
                        options: [
                            'intervalDisabled',
                            'interval1Second',
                            'interval5Seconds',
                            'interval15Seconds',
                            'interval30Seconds',
                            'interval1Minute',
                            'interval5Minutes',
                            'interval10Minutes',
                            'interval15Minutes',
                            'interval20Minutes',
                            'interval30Minutes',
                            'interval1Hour',
                        ],
                    },
                    {
                        name: 'soundMeasurementCorrectionOption',
                        type: 'choice',
                        default: 'noCorrection',
                        required: false,
                        options: ['noCorrection', 'facade', 'music', 'impulse', 'custom'],
                    },
                    {
                        name: 'soundMeasurementCorrectionValue',
                        step: 0.01,
                        type: 'float',
                        default: 0.0,
                        required: false,
                    },
                    {
                        name: 'measuringSchedule',
                        type: 'choice',
                        default: 'entireDay',
                        required: false,
                        options: ['entireDay', 'ldenTimeSettings', 'legacySettings'],
                    },
                    {
                        name: 'soundClipAlarmSource',
                        type: 'choice',
                        default: 'disabled',
                        required: false,
                        options: ['disabled', 'leq', 'lmax', 'lpeak'],
                    },
                    {
                        name: 'traceSaveLevel',
                        step: 0.01,
                        type: 'float',
                        default: 100.0,
                        required: false,
                        minValue: 50,
                        maxValue: 140,
                    },
                    {
                        name: 'tracePreTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'tracePostTrigger',
                        step: 0.01,
                        unitConversion: 'ms_to_sec',
                        type: 'float',
                        default: 3000.0,
                        required: false,
                        minValue: 1000,
                        maxValue: 4000,
                    },
                    {
                        name: 'dailyValueSettings',
                        type: 'char',
                        required: false,
                        default: {
                            triggers: [],
                            timeSettings: {
                                start: '00:00',
                                end: '23:59',
                            },
                        },
                    },
                    {
                        name: 'ldenGuideline',
                        type: 'choice',
                        required: true,
                        default: 'LdenGuidelineNone',
                        options: [
                            'LdenGuidelineNone',
                            'LdenGuidelineDutch',
                            'LdenGuidelineUK',
                            'LdenGuidelineUK2',
                            'LdenGuidelineCustom',
                        ],
                        minValue: -2147483648,
                        maxValue: 2147483647,
                    },
                    {
                        name: 'notificationConfig',
                        alarms: [
                            {
                                name: 'maxAlarms',
                                limit: 3,
                                keyTemplate: 'alarm_level_{index}',
                                showColors: true,
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0.0,
                                        required: false,
                                        minValue: 50,
                                        maxValue: 140,
                                    },
                                    {
                                        name: 'smsTemplate',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                ],
                            },
                            {
                                name: 'leqAlarms',
                                limit: 4,
                                keyTemplate: 'leq_alarm_{index}',
                                fields: [
                                    {
                                        name: 'title',
                                        type: 'char',
                                        default: '',
                                        required: false,
                                    },
                                    {
                                        name: 'interval',
                                        type: 'choice',
                                        default: 'interval_15_minutes',
                                        required: false,
                                        options: [
                                            'interval_10_minutes',
                                            'interval_15_minutes',
                                            'interval_30_minutes',
                                            'interval_1_hour',
                                            'interval_4_hours',
                                            'interval_8_hours',
                                            'interval_24_hours',
                                        ],
                                    },
                                    {
                                        name: 'alarmLevel',
                                        step: 0.01,
                                        type: 'float',
                                        default: 0.0,
                                        required: false,
                                        minValue: 50,
                                        maxValue: 140,
                                    },
                                ],
                            },
                        ],
                        type: 'char',
                        default: {
                            recipients: [],
                            ldenSchedules: [],
                            leqAlarms: [],
                            maxAlarms: [],
                            concentrationAlarms: [],
                            alarmSchedules: [],
                            emailDelay: 120,
                        },
                        required: false,
                    },
                ],
                layout: [
                    ['information', 'name'],
                    ['location', 'location'],
                    [
                        'swarmSettings',
                        [
                            ['swarmSettingsGeneral', 'disableLed'],
                            ['swarmSettingsMeasurementP1', 'vtopEnabled'],
                            ['swarmSettingsMeasurement', 'guideLine'],
                            ['swarmSettingsMeasurementP2', 'measurementDuration'],
                            ['swarmSettingsVdv', 'vdvEnabled'],
                            ['swarmSettingsDust', 'autoZeroInterval'],
                            ['swarmSettingsSound', 'soundGuideline'],
                            ['swarmSettingsSoundClip', 'soundClipAlarmSource'],
                        ],
                    ],
                    ['dailyValueSettings', 'dailyValueSettings'],
                    ['ldenGuideline', 'ldenGuideline'],
                    ['notificationConfig', 'notificationConfig'],
                    ['measurementSchedule', 'schedule'],
                    ['privateNotes', 'privateNotes'],
                ],
                information: [
                    'disableLed',
                    'logFlushInterval',
                    'timezone',
                    'guideLine',
                    'buildingLevel',
                    'atopFlatLevel',
                    'flatLevel',
                    'vtopEnabled',
                    'atopEnabled',
                    'vectorEnabled',
                    'dataSaveLevel',
                    'vdvEnabled',
                    '_group_swarmSettingsTrace',
                    'traceSaveLevel',
                    'tracePreTrigger',
                    'tracePostTrigger',
                    'noiseSavingEnabled',
                    'measurementDuration',
                    'setPointRh',
                    'kFactor',
                    'autoZeroInterval',
                    'pm2p5Factor',
                    'deviceName',
                    'project',
                    'showAlarms',
                    'showExceedancesInPdf',
                    'highestNRecords',
                    'highestReadingPerDay',
                    'privateNotes',
                    '_group_location',
                    '_group_alarmLevels',
                    'alarmLevel1SmsTemplate',
                    'notificationConfig.recipients',
                    'notificationConfig.emailDelay',
                    '_group_measurementSchedule',
                    'externalApiTarget',
                ],
                returnFields: {
                    name: null,
                    permission: null,
                    location: null,
                    privateNotes: null,
                    archived: null,
                    swarmType: null,
                    disableLed: null,
                    logFlushInterval: null,
                    timezone: null,
                    soundGuideline: null,
                    frequencyWeighting: null,
                    timeWeighting: null,
                    lxEqInterval: null,
                    lXtMinMaxInterval: null,
                    lxPeakInterval: null,
                    lXnInterval: null,
                    soundMeasurementCorrectionOption: null,
                    soundMeasurementCorrectionValue: null,
                    measuringSchedule: null,
                    soundClipAlarmSource: null,
                    traceSaveLevel: null,
                    tracePreTrigger: null,
                    tracePostTrigger: null,
                    dailyValueSettings: {
                        timeSettings: {
                            start: null,
                            end: null,
                        },
                        triggers: {
                            trigger: null,
                            days: null,
                        },
                    },
                    ldenGuideline: null,
                    notificationConfig: {
                        recipients: {
                            enabledAlarms: null,
                            email: null,
                            phoneNumber: null,
                            webhook: {
                                endpoint: null,
                                secret: null,
                            },
                        },
                        ldenSchedules: {
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            name: null,
                            warningLevel: null,
                            alarmLevel: null,
                            correction: null,
                        },
                        leqAlarms: {
                            interval: null,
                            alarmLevel: null,
                            key: null,
                            title: null,
                        },
                        maxAlarms: {
                            key: null,
                            title: null,
                            alarmLevel: null,
                            smsTemplate: null,
                        },
                        concentrationAlarms: {
                            key: null,
                            title: null,
                            interval: null,
                            alarmLevel: null,
                            particleType: null,
                        },
                        alarmSchedules: {
                            title: null,
                            startDay: null,
                            startTime: null,
                            endDay: null,
                            endTime: null,
                            maxAlarms: {
                                key: null,
                                title: null,
                                alarmLevel: null,
                                smsTemplate: null,
                            },
                            leqAlarms: {
                                interval: null,
                                alarmLevel: null,
                                key: null,
                                title: null,
                            },
                            concentrationAlarms: {
                                key: null,
                                title: null,
                                interval: null,
                                alarmLevel: null,
                                particleType: null,
                            },
                        },
                        emailDelay: null,
                    },
                    id: null,
                },
                translationPrefix: 'SOUND_PROJECT',
            },
        },
    ],
    configHelper: {
        configFields: {
            swarmType: {
                vibration: {
                    guideLine: {
                        SBR_A_2010: {
                            buildingLevel: {
                                lowerLevel: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                highestFloor: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                foundation: {
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                pipeline: {
                                    pipelineType: {
                                        weldedSteel: {},
                                        concreteAndSteel: {},
                                        brickworkAndPlastic: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        SBR_A_2017: {
                            buildingLevel: {
                                foundation: {
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    buildingState: {
                                        normal: {},
                                        sensitive: {},
                                    },
                                    zetGevLaagdikte: {
                                        H_1m: {},
                                        H_2m: {},
                                        H_3m: {},
                                        H_4m: {},
                                        H_5m: {},
                                        H_6m: {},
                                        H_7m: {},
                                        H_8m: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                lowerLevel: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    buildingState: {
                                        normal: {},
                                        sensitive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                highestFloor: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    buildingState: {
                                        normal: {},
                                        sensitive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                pipeline: {
                                    pipelineType: {
                                        weldedSteel: {},
                                        concreteAndSteel: {},
                                        brickworkAndPlastic: {},
                                    },
                                    vibrationType: {
                                        continuous: {},
                                        repeated: {},
                                        shortTerm: {},
                                    },
                                    measuringType: {
                                        indicative: {},
                                        limited: {},
                                        extensive: {},
                                    },
                                    buildingState: {
                                        normal: {},
                                        sensitive: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        DIN4150_3_80Hz: {
                            buildingLevel: {
                                highestFloor: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vibrationType: {
                                        shortTerm: {},
                                        longTerm: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                floorSlabs: {
                                    vibrationType: {
                                        shortTerm: {},
                                        longTerm: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                dinFoundation: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                pipeline: {
                                    pipelineType: {
                                        weldedSteel: {},
                                        concreteAndSteel: {},
                                        brickworkAndPlastic: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                undergroundCavities: {
                                    liningMaterial: {
                                        reinforcedConcreteAndTubing: {},
                                        concreteAndStone: {},
                                        masonry: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        DIN4150_3_315Hz: {
                            buildingLevel: {
                                highestFloor: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vibrationType: {
                                        shortTerm: {},
                                        longTerm: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                floorSlabs: {
                                    vibrationType: {
                                        shortTerm: {},
                                        longTerm: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                dinFoundation: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                        CAT3: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                pipeline: {
                                    pipelineType: {
                                        weldedSteel: {},
                                        concreteAndSteel: {},
                                        brickworkAndPlastic: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                undergroundCavities: {
                                    liningMaterial: {
                                        reinforcedConcreteAndTubing: {},
                                        concreteAndStone: {},
                                        masonry: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        BS7385_250Hz: {
                            buildingLevel: {
                                guidelineValues: {
                                    category: {
                                        CAT1: {},
                                        CAT2: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        Circulaire86: {
                            buildingLevel: {
                                guidelineValues: {
                                    vibrationType: {
                                        continuous: {},
                                        peak: {},
                                    },
                                    constructionType: {
                                        resistantConstruction: {},
                                        sensitiveConstruction: {},
                                        verySensitiveConstruction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        IN1226: {
                            buildingLevel: {
                                freshConcrete: {
                                    concreteSettingLevel: {
                                        lessThan2hours: {
                                            vibrationSource: {
                                                blasting: {},
                                                mechanicalDevices: {
                                                    vibrationType: {
                                                        continuous: {},
                                                        repeated: {},
                                                    },
                                                },
                                            },
                                        },
                                        lessThan10MPa: {},
                                        rc10MPaTo15MPa: {},
                                        moreThan15MPa: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                structure: {
                                    vibrationSource: {
                                        blasting: {
                                            constructionType: {
                                                resistantConstruction: {},
                                                sensitiveConstruction: {},
                                                verySensitiveConstruction: {},
                                                platformAndCatenaryPost: {},
                                            },
                                        },
                                        mechanicalDevices: {
                                            vibrationType: {
                                                continuous: {
                                                    constructionType: {
                                                        resistantConstruction: {},
                                                        sensitiveConstruction: {},
                                                        verySensitiveConstruction: {},
                                                        platformAndCatenaryPost: {},
                                                    },
                                                },
                                                repeated: {
                                                    constructionType: {
                                                        resistantConstruction: {},
                                                        sensitiveConstruction: {},
                                                        verySensitiveConstruction: {},
                                                        platformAndCatenaryPost: {},
                                                    },
                                                },
                                            },
                                        },
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        SBR_B_2002: {
                            veffBuildingType: {
                                healthcare: {},
                                residential: {},
                                officeAndEducation: {},
                                meetingBuildings: {},
                                criticalWorkspaces: {},
                            },
                            veffCircumstance: {
                                continuousOrRepeatedShortTerm: {
                                    veffDurationOfActivities: {
                                        oneDay: {},
                                        twoDays: {},
                                        threeDays: {},
                                        fourDays: {},
                                        fiveDays: {},
                                        sixToTwentySixDays: {},
                                        twentySevenToSeventyEightDays: {},
                                    },
                                },
                                continuousLongTerm: {},
                                incidental: {},
                                repeatedLongTerm: {
                                    veffSituation: {
                                        changed: {
                                            veffVmaxCompliedBeforeChange: {
                                                true: {
                                                    veffCustomLimitDayA1: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitDayA2: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitDayA3: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitEveningA1: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitEveningA2: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitEveningA3: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitNightA1: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitNightA2: {
                                                        __any__: {},
                                                    },
                                                    veffCustomLimitNightA3: {
                                                        __any__: {},
                                                    },
                                                },
                                                false: {},
                                            },
                                        },
                                        new: {},
                                        existing: {},
                                    },
                                },
                            },
                            veffLowerProtection: {
                                false: {},
                                true: {},
                            },
                        },
                        DIN4150_2: {
                            kbfSource: {
                                infrequentShortTerm: {
                                    veffBuildingType: {
                                        industrial: {},
                                        commercial: {},
                                        mixed: {},
                                        residential: {},
                                        healthcare: {},
                                    },
                                },
                                roadTraffic: {
                                    veffBuildingType: {
                                        industrial: {},
                                        commercial: {},
                                        mixed: {},
                                        residential: {},
                                        healthcare: {},
                                    },
                                },
                                railTraffic: {
                                    kbfRailTraffic: {
                                        underground: {},
                                        surfaceUrban: {},
                                        surfaceNonUrban: {},
                                    },
                                    veffBuildingType: {
                                        industrial: {},
                                        commercial: {},
                                        mixed: {},
                                        residential: {},
                                        healthcare: {},
                                    },
                                },
                                construction: {
                                    veffDurationOfActivities: {
                                        oneDay: {},
                                        twoDays: {},
                                        threeDays: {},
                                        fourDays: {},
                                        fiveDays: {},
                                        sixToTwentySixDays: {},
                                        twentySevenToSeventyEightDays: {},
                                    },
                                    veffBuildingType: {
                                        industrial: {
                                            kbfVibrationLevel: {
                                                level1: {},
                                                level2: {},
                                                level3: {},
                                            },
                                        },
                                        commercial: {
                                            kbfVibrationLevel: {
                                                level1: {},
                                                level2: {},
                                                level3: {},
                                            },
                                        },
                                        mixed: {
                                            kbfVibrationLevel: {
                                                level1: {},
                                                level2: {},
                                                level3: {},
                                            },
                                        },
                                        residential: {
                                            kbfVibrationLevel: {
                                                level1: {},
                                                level2: {},
                                                level3: {},
                                            },
                                        },
                                        healthcare: {
                                            kbfCustomLimitDayAu: {
                                                __any__: {},
                                            },
                                            kbfCustomLimitDayAo: {
                                                __any__: {},
                                            },
                                            kbfCustomLimitDayAr: {
                                                __any__: {},
                                            },
                                            kbfCustomLimitNightAu: {
                                                __any__: {},
                                            },
                                            kbfCustomLimitNightAo: {
                                                __any__: {},
                                            },
                                            kbfCustomLimitNightAr: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                },
                            },
                        },
                        SS_4604861: {},
                        ISEE_250Hz: {
                            buildingLevel: {
                                USBM_RI8507_drywall: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                USBM_RI8507_plaster: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                OSMRE_1983: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        ONORM_S_9020: {
                            buildingLevel: {
                                guidelineValues: {
                                    sensitivityClass: {
                                        sensitivityClass0: {},
                                        sensitivityClass1: {},
                                        sensitivityClass2: {},
                                        sensitivityClass3: {},
                                        sensitivityClass4: {},
                                    },
                                    vibrationType: {
                                        impulsive: {},
                                        momentarily: {},
                                        continually: {},
                                    },
                                    frequencyClass: {
                                        rarely: {},
                                        repetitive: {},
                                        frequently: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        UNE_22_381_93: {
                            buildingLevel: {
                                guidelineValues: {
                                    constructionType: {
                                        structureType1: {},
                                        structureType2: {},
                                        structureType3: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        SS_025211: {
                            buildingLevel: {
                                buildingClass1: {
                                    constructionType: {
                                        designClass1: {},
                                        designClass2: {},
                                        designClass3: {},
                                    },
                                    liningMaterial: {
                                        materialClass1: {},
                                        materialClass2: {},
                                        materialClass3: {},
                                        materialClass4: {},
                                    },
                                    underground: {
                                        claySiltSandGravel: {},
                                        moraine: {},
                                        mountain: {},
                                    },
                                    vibrationSource: {
                                        pilingSheetingExcavation: {},
                                        compaction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                buildingClass2: {
                                    constructionType: {
                                        designClass1: {},
                                        designClass2: {},
                                        designClass3: {},
                                    },
                                    liningMaterial: {
                                        materialClass1: {},
                                        materialClass2: {},
                                        materialClass3: {},
                                        materialClass4: {},
                                    },
                                    underground: {
                                        claySiltSandGravel: {},
                                        moraine: {},
                                        mountain: {},
                                    },
                                    vibrationSource: {
                                        pilingSheetingExcavation: {},
                                        compaction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                buildingClass3: {
                                    constructionType: {
                                        designClass1: {},
                                        designClass2: {},
                                        designClass3: {},
                                    },
                                    liningMaterial: {
                                        materialClass1: {},
                                        materialClass2: {},
                                        materialClass3: {},
                                        materialClass4: {},
                                    },
                                    underground: {
                                        claySiltSandGravel: {},
                                        moraine: {},
                                        mountain: {},
                                    },
                                    vibrationSource: {
                                        pilingSheetingExcavation: {},
                                        compaction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                buildingClass4: {
                                    constructionType: {
                                        designClass1: {},
                                        designClass2: {},
                                        designClass3: {},
                                    },
                                    liningMaterial: {
                                        materialClass1: {},
                                        materialClass2: {},
                                        materialClass3: {},
                                        materialClass4: {},
                                    },
                                    underground: {
                                        claySiltSandGravel: {},
                                        moraine: {},
                                        mountain: {},
                                    },
                                    vibrationSource: {
                                        pilingSheetingExcavation: {},
                                        compaction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                buildingClass5: {
                                    constructionType: {
                                        designClass1: {},
                                        designClass2: {},
                                        designClass3: {},
                                    },
                                    liningMaterial: {
                                        materialClass1: {},
                                        materialClass2: {},
                                        materialClass3: {},
                                        materialClass4: {},
                                    },
                                    underground: {
                                        claySiltSandGravel: {},
                                        moraine: {},
                                        mountain: {},
                                    },
                                    vibrationSource: {
                                        pilingSheetingExcavation: {},
                                        compaction: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        NS_8141_1_2022: {
                            buildingLevel: {
                                residentialBuildings: {
                                    liningMaterial: {
                                        unreinforcedConcreteBrickEtc: {},
                                        reinforcedConcreteSteelWood: {},
                                        aeratedConcreteAndDelicateDetails: {},
                                    },
                                    groundCondition: {
                                        soil: {},
                                        denseMoraineAndCompactedFillOver2m: {},
                                        rock: {},
                                    },
                                    foundationType: {
                                        foundationOnOrInSoil: {},
                                        foundationOnRock: {},
                                    },
                                    vibrationSource: {
                                        blasting: {},
                                        licensedQuarryAndMiningBlasting: {},
                                        constructionActivities: {},
                                        vibratoryActivities: {},
                                    },
                                    sourceDistance: {
                                        __any__: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                industrialAndOfficeBuildings: {
                                    liningMaterial: {
                                        unreinforcedConcreteBrickEtc: {},
                                        reinforcedConcreteSteelWood: {},
                                        aeratedConcreteAndDelicateDetails: {},
                                    },
                                    groundCondition: {
                                        soil: {},
                                        denseMoraineAndCompactedFillOver2m: {},
                                        rock: {},
                                    },
                                    foundationType: {
                                        foundationOnOrInSoil: {},
                                        foundationOnRock: {},
                                    },
                                    vibrationSource: {
                                        blasting: {},
                                        licensedQuarryAndMiningBlasting: {},
                                        constructionActivities: {},
                                        vibratoryActivities: {},
                                    },
                                    sourceDistance: {
                                        __any__: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                heavyStructures: {
                                    liningMaterial: {
                                        unreinforcedConcreteBrickEtc: {},
                                        reinforcedConcreteSteelWood: {},
                                        aeratedConcreteAndDelicateDetails: {},
                                    },
                                    groundCondition: {
                                        soil: {},
                                        denseMoraineAndCompactedFillOver2m: {},
                                        rock: {},
                                    },
                                    foundationType: {
                                        foundationOnOrInSoil: {},
                                        foundationOnRock: {},
                                    },
                                    vibrationSource: {
                                        blasting: {},
                                        licensedQuarryAndMiningBlasting: {},
                                        constructionActivities: {},
                                        vibratoryActivities: {},
                                    },
                                    sourceDistance: {
                                        __any__: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                sensitiveBuildings: {
                                    liningMaterial: {
                                        unreinforcedConcreteBrickEtc: {},
                                        reinforcedConcreteSteelWood: {},
                                    },
                                    groundCondition: {
                                        soil: {},
                                        denseMoraineAndCompactedFillOver2m: {},
                                        rock: {},
                                    },
                                    foundationType: {
                                        foundationOnOrInSoil: {},
                                        foundationOnRock: {},
                                    },
                                    vibrationSource: {
                                        blasting: {},
                                        licensedQuarryAndMiningBlasting: {},
                                        constructionActivities: {},
                                        vibratoryActivities: {},
                                    },
                                    sourceDistance: {
                                        __any__: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                        SN640312a: {
                            buildingLevel: {
                                guidelineValues: {
                                    frequencyClass: {
                                        occasionally: {},
                                        often: {},
                                        permanent: {},
                                    },
                                    sensitivityClass: {
                                        veryLittle: {},
                                        little: {},
                                        scNormal: {},
                                        elevated: {},
                                    },
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                },
                                unspecified: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    flatLevel: {
                                        __any__: {},
                                    },
                                },
                                selfDefined: {
                                    vtopEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    dataSaveLevel: {
                                        __any__: {},
                                    },
                                    measurementDuration: {
                                        __any__: {},
                                    },
                                    noiseSavingEnabled: {
                                        false: {},
                                        true: {
                                            noiseMeasurementDuration: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    atopEnabled: {
                                        false: {},
                                        true: {
                                            atopFlatLevel: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    vectorEnabled: {
                                        false: {},
                                        true: {},
                                    },
                                    selfDefinedAlarmLine: {
                                        __any__: {},
                                    },
                                },
                            },
                        },
                    },
                    vdvEnabled: {
                        false: {},
                        true: {
                            vdvPeriod: {
                                __any__: {},
                            },
                            vdvX: {
                                ISO2631_Wc: {},
                                ISO2631_Wd: {},
                                ISO2631_We: {},
                                ISO2631_Wf: {},
                                ISO2631_Wj: {},
                                ISO2631_Wk: {},
                                ISO2631_Wm: {},
                                BS6841_Wb: {},
                                BS6841_Wc: {},
                                BS6841_Wd: {},
                                BS6841_We: {},
                                BS6841_Wf: {},
                                BS6841_Wg: {},
                                ISO5349_Wh: {},
                                ISO8041_Wh: {},
                            },
                            vdvY: {
                                ISO2631_Wc: {},
                                ISO2631_Wd: {},
                                ISO2631_We: {},
                                ISO2631_Wf: {},
                                ISO2631_Wj: {},
                                ISO2631_Wk: {},
                                ISO2631_Wm: {},
                                BS6841_Wb: {},
                                BS6841_Wc: {},
                                BS6841_Wd: {},
                                BS6841_We: {},
                                BS6841_Wf: {},
                                BS6841_Wg: {},
                                ISO5349_Wh: {},
                                ISO8041_Wh: {},
                            },
                            vdvZ: {
                                ISO2631_Wc: {},
                                ISO2631_Wd: {},
                                ISO2631_We: {},
                                ISO2631_Wf: {},
                                ISO2631_Wj: {},
                                ISO2631_Wk: {},
                                ISO2631_Wm: {},
                                BS6841_Wb: {},
                                BS6841_Wc: {},
                                BS6841_Wd: {},
                                BS6841_We: {},
                                BS6841_Wf: {},
                                BS6841_Wg: {},
                                ISO5349_Wh: {},
                                ISO8041_Wh: {},
                            },
                        },
                    },
                    traceSaveLevel: {
                        __any__: {},
                    },
                    tracePreTrigger: {
                        __any__: {},
                    },
                    tracePostTrigger: {
                        __any__: {},
                    },
                },
                air: {
                    autoZeroInterval: {
                        __any__: {},
                    },
                    setPointRh: {
                        __any__: {},
                    },
                    kFactor: {
                        __any__: {},
                    },
                    particleType: {
                        PM10: {
                            pm2p5Factor: {
                                __any__: {},
                            },
                        },
                        TSP: {},
                        PM1: {},
                        PM2p5: {},
                    },
                },
                sound: {
                    externalApiTarget: {
                        noExternalApi: {
                            soundGuideline: {
                                IEC_61672: {
                                    frequencyWeighting: {
                                        frequencyWeightingA: {},
                                        frequencyWeightingB: {},
                                        frequencyWeightingC: {},
                                        frequencyWeightingZ: {},
                                    },
                                    timeWeighting: {
                                        timeWeightingFast: {},
                                        timeWeightingSlow: {},
                                    },
                                    lxEqInterval: {
                                        intervalDisabled: {},
                                        interval1Second: {},
                                        interval5Seconds: {},
                                        interval15Seconds: {},
                                        interval30Seconds: {},
                                        interval1Minute: {},
                                        interval5Minutes: {},
                                        interval10Minutes: {},
                                        interval15Minutes: {},
                                        interval20Minutes: {},
                                        interval30Minutes: {},
                                        interval1Hour: {},
                                    },
                                    lXtMinMaxInterval: {
                                        intervalDisabled: {},
                                        interval1Second: {},
                                        interval5Seconds: {},
                                        interval15Seconds: {},
                                        interval30Seconds: {},
                                        interval1Minute: {},
                                        interval5Minutes: {},
                                        interval10Minutes: {},
                                        interval15Minutes: {},
                                        interval20Minutes: {},
                                        interval30Minutes: {},
                                        interval1Hour: {},
                                    },
                                    lxPeakInterval: {
                                        intervalDisabled: {},
                                        interval1Second: {},
                                        interval5Seconds: {},
                                        interval15Seconds: {},
                                        interval30Seconds: {},
                                        interval1Minute: {},
                                        interval5Minutes: {},
                                        interval10Minutes: {},
                                        interval15Minutes: {},
                                        interval20Minutes: {},
                                        interval30Minutes: {},
                                        interval1Hour: {},
                                    },
                                    lXnInterval: {
                                        intervalDisabled: {},
                                        interval5Minutes: {},
                                        interval10Minutes: {},
                                        interval15Minutes: {},
                                        interval20Minutes: {},
                                        interval30Minutes: {},
                                        interval1Hour: {},
                                    },
                                    soundMeasurementCorrectionOption: {
                                        noCorrection: {},
                                        impulse: {},
                                        music: {},
                                        facade: {},
                                        custom: {
                                            soundMeasurementCorrectionValue: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    ldenGuideline: {
                                        __any__: {},
                                    },
                                    measuringSchedule: {
                                        entireDay: {},
                                        ldenTimeSettings: {},
                                    },
                                    soundClipAlarmSource: {
                                        disabled: {},
                                        leq: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                        lmax: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                        lpeak: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                },
                            },
                        },
                        newYorkApi: {
                            soundGuideline: {
                                IEC_61672: {
                                    frequencyWeighting: {
                                        frequencyWeightingA: {},
                                    },
                                    timeWeighting: {
                                        timeWeightingSlow: {},
                                    },
                                    lxEqInterval: {
                                        interval5Minutes: {},
                                    },
                                    lXtMinMaxInterval: {
                                        interval5Minutes: {},
                                    },
                                    lxPeakInterval: {
                                        __any__: {},
                                    },
                                    lXnInterval: {
                                        __any__: {},
                                    },
                                    soundMeasurementCorrectionOption: {
                                        noCorrection: {},
                                        impulse: {},
                                        music: {},
                                        facade: {},
                                        custom: {
                                            soundMeasurementCorrectionValue: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                    ldenGuideline: {
                                        __any__: {},
                                    },
                                    measuringSchedule: {
                                        entireDay: {},
                                    },
                                    soundClipAlarmSource: {
                                        disabled: {},
                                        leq: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                        lmax: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                        lpeak: {
                                            traceSaveLevel: {
                                                __any__: {},
                                            },
                                            tracePreTrigger: {
                                                __any__: {},
                                            },
                                            tracePostTrigger: {
                                                __any__: {},
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        allFields: [
            'guideLine',
            'buildingLevel',
            'category',
            'vibrationType',
            'measuringType',
            'vtopEnabled',
            'dataSaveLevel',
            'measurementDuration',
            'noiseSavingEnabled',
            'noiseMeasurementDuration',
            'atopEnabled',
            'atopFlatLevel',
            'vectorEnabled',
            'pipelineType',
            'flatLevel',
            'selfDefinedAlarmLine',
            'buildingState',
            'zetGevLaagdikte',
            'liningMaterial',
            'constructionType',
            'concreteSettingLevel',
            'vibrationSource',
            'veffBuildingType',
            'veffCircumstance',
            'veffDurationOfActivities',
            'veffSituation',
            'veffVmaxCompliedBeforeChange',
            'veffCustomLimitDayA1',
            'veffCustomLimitDayA2',
            'veffCustomLimitDayA3',
            'veffCustomLimitEveningA1',
            'veffCustomLimitEveningA2',
            'veffCustomLimitEveningA3',
            'veffCustomLimitNightA1',
            'veffCustomLimitNightA2',
            'veffCustomLimitNightA3',
            'veffLowerProtection',
            'kbfSource',
            'kbfRailTraffic',
            'kbfVibrationLevel',
            'kbfCustomLimitDayAu',
            'kbfCustomLimitDayAo',
            'kbfCustomLimitDayAr',
            'kbfCustomLimitNightAu',
            'kbfCustomLimitNightAo',
            'kbfCustomLimitNightAr',
            'sensitivityClass',
            'frequencyClass',
            'underground',
            'groundCondition',
            'foundationType',
            'sourceDistance',
            'vdvEnabled',
            'vdvPeriod',
            'vdvX',
            'vdvY',
            'vdvZ',
            'traceSaveLevel',
            'tracePreTrigger',
            'tracePostTrigger',
            'autoZeroInterval',
            'setPointRh',
            'kFactor',
            'particleType',
            'pm2p5Factor',
            'externalApiTarget',
            'soundGuideline',
            'frequencyWeighting',
            'timeWeighting',
            'lxEqInterval',
            'lXtMinMaxInterval',
            'lxPeakInterval',
            'lXnInterval',
            'soundMeasurementCorrectionOption',
            'soundMeasurementCorrectionValue',
            'ldenGuideline',
            'measuringSchedule',
            'soundClipAlarmSource',
        ],
        neverAllowedFeatures: {
            vibration: {
                swarmType: '__any__',
                guideLine: 'DIN4150_3_315Hz',
            },
            air: {
                swarmType: '__any__',
            },
            sound: {
                swarmType: '__any__',
            },
        },
    },
    namingConventions: {
        defaultGuideline: 'DIN4150_3_80Hz',
    },
    partialConfigLayoutSections: {
        general: 'swarmSettings',
        notification: 'notificationConfig',
        schedule: 'measurementSchedule',
        daily_value_settings: 'dailyValueSettings',
        lden_guideline: 'ldenGuideline',
    },
    partialConfigMatrix: {
        vibration: ['GENERAL', 'NOTIFICATION', 'SCHEDULE'],
        air: ['GENERAL', 'NOTIFICATION'],
        sound: ['GENERAL', 'NOTIFICATION', 'DAILY_VALUE_SETTINGS', 'LDEN_GUIDELINE'],
    },
    pm10ExportOptions: {
        PM10_1_MINUTE: 'pm10_1m',
        PM10_15_MINUTE: 'pm10_15m',
        PM10_60_MINUTE: 'pm10_60m',
        PM10_1440_MINUTE: 'pm10_1440m',
    },
    pm2p5ExportOptions: {
        PM2P5_1_MINUTE: 'pm2p5_1m',
        PM2P5_15_MINUTE: 'pm2p5_15m',
        PM2P5_60_MINUTE: 'pm2p5_60m',
        PM2P5_1440_MINUTE: 'pm2p5_1440m',
    },
    reportTemplatePageMargin: {
        minValue: 0.0,
        decimalPlaces: 2,
        maxValueByUnit: {
            CM: 10.0,
            IN: 4.0,
        },
    },
    customAlarmLevelPreviewGuidelines: [
        'SBR_A_2010',
        'DIN4150_3_80Hz',
        'SBR_A_2017',
        'DIN4150_3_315Hz',
        'BS7385_250Hz',
        'Circulaire86',
        'ISEE_250Hz',
        'SN640312a',
        'IN1226',
        'ONORM_S_9020',
        'UNE_22_381_93',
        'SS_025211',
        'NS_8141_1_2022',
    ],
    lnLevels: [10, 50, 90],
    loginUrlPath: '/account/login/',
    signupUrlPath: '/accounts/signup/',
    logoutUrlPath: '/accounts/logout/',
    menu: [
        {
            checks: ['isAuthenticated', 'isReseller'],
            id: 'id_dealer_menu',
            children: [
                {
                    url: '/reseller/edit',
                    id: 'id_reseller_edit',
                },
            ],
        },
        {
            checks: ['isAuthenticated'],
            id: 'id_account_menu',
            children: [
                {
                    url: '/accounts/update/',
                    id: 'id_accounts_update',
                },
                {
                    url: '/account/two_factor/',
                    id: 'id_account_two_factor',
                },
                {
                    url: '/sharing/share-user-edit/',
                    id: 'id_sharing_share-user-edit',
                },
                {
                    checks: ['isAuthenticated', 'canAccessLegacyPdfTemplates'],
                    url: '/reports/templates/',
                    id: 'id_reports_templates',
                },
                {
                    url: '/reports/builder/',
                    id: 'id_reports_builder',
                },
                {
                    url: '/reports/downloads',
                    id: 'id_reports_downloads',
                },
                {
                    url: '/address_book/',
                    id: 'id_address_book',
                },
                {
                    checks: ['isCustomer'],
                    url: '/accounting/diagnosis',
                    id: 'id_accounting_diagnosis',
                },
                {
                    checks: ['isCustomer'],
                    url: '/accounting/subscriptions',
                    id: 'id_accounting_subscriptions',
                },
                {
                    checks: ['isCustomer'],
                    url: '/accounting/invoices',
                    id: 'id_accounting_invoices',
                },
            ],
        },
        {
            checks: ['isAuthenticated'],
            id: 'id_measuring_point',
            children: [
                {
                    url: '/overview/',
                    id: 'id_overview',
                },
                {
                    id: 'id_create_measuring_point',
                    children: [
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-vibration-icon',
                            url: '/measuring_point/create/vibration',
                            id: 'id_measuring_point_create_vibration',
                        },
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-air-icon',
                            url: '/measuring_point/create/air',
                            id: 'id_measuring_point_create_air',
                        },
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-sound-icon',
                            url: '/measuring_point/create/sound',
                            id: 'id_measuring_point_create_sound',
                        },
                    ],
                },
                {
                    id: 'id_create_project',
                    children: [
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-vibration-icon',
                            url: '/project/create/vibration',
                            id: 'id_project_create_vibration',
                        },
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-air-icon',
                            url: '/project/create/air',
                            id: 'id_project_create_air',
                        },
                        {
                            checks: ['isAuthenticated'],
                            swarmIcon: 'swarm-sound-icon',
                            url: '/project/create/sound',
                            id: 'id_project_create_sound',
                        },
                    ],
                },
                {
                    url: '/alarm_level/',
                    id: 'id_alarm_level',
                },
            ],
        },
        {
            checks: ['isAuthenticated'],
            url: '/notifications/',
            id: 'id_notifications',
        },
        {
            checks: ['isAuthenticated'],
            url: '/map/',
            id: 'id_map',
        },
        {
            checks: ['isAuthenticated'],
            url: '/sbr/sbrView/',
            id: 'id_sbr_sbrView',
        },
        {
            showHelpIcon: true,
            checks: ['isAuthenticated'],
            id: 'id_help',
            children: [
                {
                    url: '/walkthroughs/',
                    id: 'id_walkthroughs',
                },
                {
                    url: 'https://www.omnidots.com/{{LANGUAGE_CODE}}/videos',
                    id: 'id_https:__www.omnidots.com_{{LANGUAGE_CODE}}_videos',
                },
                {
                    url: 'https://www.omnidots.com/{{LANGUAGE_CODE}}/faq',
                    id: 'id_https:__www.omnidots.com_{{LANGUAGE_CODE}}_faq',
                },
            ],
        },
    ],
    ldenGuidelines: {
        LdenGuidelineNone: [],
        LdenGuidelineDutch: [
            {
                startDay: 0,
                startTime: 700,
                endDay: 0,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 0,
                startTime: 1900,
                endDay: 0,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 0,
                startTime: 2300,
                endDay: 1,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 1,
                startTime: 700,
                endDay: 1,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 1,
                startTime: 1900,
                endDay: 1,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 1,
                startTime: 2300,
                endDay: 2,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 2,
                startTime: 700,
                endDay: 2,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 2,
                startTime: 1900,
                endDay: 2,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 2,
                startTime: 2300,
                endDay: 3,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 3,
                startTime: 700,
                endDay: 3,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 3,
                startTime: 1900,
                endDay: 3,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 3,
                startTime: 2300,
                endDay: 4,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 4,
                startTime: 700,
                endDay: 4,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 4,
                startTime: 1900,
                endDay: 4,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 4,
                startTime: 2300,
                endDay: 5,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 5,
                startTime: 700,
                endDay: 5,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 5,
                startTime: 1900,
                endDay: 5,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 5,
                startTime: 2300,
                endDay: 6,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
            {
                startDay: 6,
                startTime: 700,
                endDay: 6,
                endTime: 1900,
                name: 'Ldag',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 0.0,
            },
            {
                startDay: 6,
                startTime: 1900,
                endDay: 6,
                endTime: 2300,
                name: 'Lavond',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 5,
            },
            {
                startDay: 6,
                startTime: 2300,
                endDay: 0,
                endTime: 700,
                name: 'Lnacht',
                warningLevel: 90,
                alarmLevel: 100,
                correction: 10,
            },
        ],
        LdenGuidelineUK: [
            {
                startDay: 1,
                startTime: 800,
                endDay: 1,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
            {
                startDay: 2,
                startTime: 800,
                endDay: 2,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
            {
                startDay: 3,
                startTime: 800,
                endDay: 3,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
            {
                startDay: 4,
                startTime: 800,
                endDay: 4,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
            {
                startDay: 5,
                startTime: 800,
                endDay: 5,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
            {
                startDay: 6,
                startTime: 800,
                endDay: 6,
                endTime: 1200,
                name: 'Lsaturday',
                warningLevel: 100,
                alarmLevel: 110,
                correction: 0.0,
            },
        ],
        LdenGuidelineUK2: [
            {
                startDay: 1,
                startTime: 800,
                endDay: 1,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
            {
                startDay: 2,
                startTime: 800,
                endDay: 2,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
            {
                startDay: 3,
                startTime: 800,
                endDay: 3,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
            {
                startDay: 4,
                startTime: 800,
                endDay: 4,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
            {
                startDay: 5,
                startTime: 800,
                endDay: 5,
                endTime: 1800,
                name: 'Lweekday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
            {
                startDay: 6,
                startTime: 800,
                endDay: 6,
                endTime: 1300,
                name: 'Lsaturday',
                warningLevel: 75,
                alarmLevel: 78,
                correction: 0.0,
            },
        ],
        LdenGuidelineCustom: [],
    },
    maxAlarmKeys: 100,
    nonConformingCountries: [597],
    distanceUnitDigits: {
        mm: 1,
        cm: 2,
        inch: 3,
        mil: 0,
    },
    distanceUnitMultipliers: {
        mm: 1.0,
        cm: 10.0,
        inch: 25.4,
        mil: 0.0254,
    },
    distanceUnitLabels: {
        cm: 'cm',
        mm: 'mm',
        inch: 'in',
        mil: 'mil',
    },
    timezoneGraphqlEnumMap: {
        'Africa/Abidjan': 'Africa_Abidjan',
        'Africa/Accra': 'Africa_Accra',
        'Africa/Addis_Ababa': 'Africa_Addis_Ababa',
        'Africa/Algiers': 'Africa_Algiers',
        'Africa/Asmara': 'Africa_Asmara',
        'Africa/Asmera': 'Africa_Asmera',
        'Africa/Bamako': 'Africa_Bamako',
        'Africa/Bangui': 'Africa_Bangui',
        'Africa/Banjul': 'Africa_Banjul',
        'Africa/Bissau': 'Africa_Bissau',
        'Africa/Blantyre': 'Africa_Blantyre',
        'Africa/Brazzaville': 'Africa_Brazzaville',
        'Africa/Bujumbura': 'Africa_Bujumbura',
        'Africa/Cairo': 'Africa_Cairo',
        'Africa/Casablanca': 'Africa_Casablanca',
        'Africa/Ceuta': 'Africa_Ceuta',
        'Africa/Conakry': 'Africa_Conakry',
        'Africa/Dakar': 'Africa_Dakar',
        'Africa/Dar_es_Salaam': 'Africa_Dar_es_Salaam',
        'Africa/Djibouti': 'Africa_Djibouti',
        'Africa/Douala': 'Africa_Douala',
        'Africa/El_Aaiun': 'Africa_El_Aaiun',
        'Africa/Freetown': 'Africa_Freetown',
        'Africa/Gaborone': 'Africa_Gaborone',
        'Africa/Harare': 'Africa_Harare',
        'Africa/Johannesburg': 'Africa_Johannesburg',
        'Africa/Juba': 'Africa_Juba',
        'Africa/Kampala': 'Africa_Kampala',
        'Africa/Khartoum': 'Africa_Khartoum',
        'Africa/Kigali': 'Africa_Kigali',
        'Africa/Kinshasa': 'Africa_Kinshasa',
        'Africa/Lagos': 'Africa_Lagos',
        'Africa/Libreville': 'Africa_Libreville',
        'Africa/Lome': 'Africa_Lome',
        'Africa/Luanda': 'Africa_Luanda',
        'Africa/Lubumbashi': 'Africa_Lubumbashi',
        'Africa/Lusaka': 'Africa_Lusaka',
        'Africa/Malabo': 'Africa_Malabo',
        'Africa/Maputo': 'Africa_Maputo',
        'Africa/Maseru': 'Africa_Maseru',
        'Africa/Mbabane': 'Africa_Mbabane',
        'Africa/Mogadishu': 'Africa_Mogadishu',
        'Africa/Monrovia': 'Africa_Monrovia',
        'Africa/Nairobi': 'Africa_Nairobi',
        'Africa/Ndjamena': 'Africa_Ndjamena',
        'Africa/Niamey': 'Africa_Niamey',
        'Africa/Nouakchott': 'Africa_Nouakchott',
        'Africa/Ouagadougou': 'Africa_Ouagadougou',
        'Africa/Porto-Novo': 'Africa_PortoMinusNovo',
        'Africa/Sao_Tome': 'Africa_Sao_Tome',
        'Africa/Timbuktu': 'Africa_Timbuktu',
        'Africa/Tripoli': 'Africa_Tripoli',
        'Africa/Tunis': 'Africa_Tunis',
        'Africa/Windhoek': 'Africa_Windhoek',
        'America/Adak': 'America_Adak',
        'America/Anchorage': 'America_Anchorage',
        'America/Anguilla': 'America_Anguilla',
        'America/Antigua': 'America_Antigua',
        'America/Araguaina': 'America_Araguaina',
        'America/Argentina/Buenos_Aires': 'America_Argentina_Buenos_Aires',
        'America/Argentina/Catamarca': 'America_Argentina_Catamarca',
        'America/Argentina/ComodRivadavia': 'America_Argentina_ComodRivadavia',
        'America/Argentina/Cordoba': 'America_Argentina_Cordoba',
        'America/Argentina/Jujuy': 'America_Argentina_Jujuy',
        'America/Argentina/La_Rioja': 'America_Argentina_La_Rioja',
        'America/Argentina/Mendoza': 'America_Argentina_Mendoza',
        'America/Argentina/Rio_Gallegos': 'America_Argentina_Rio_Gallegos',
        'America/Argentina/Salta': 'America_Argentina_Salta',
        'America/Argentina/San_Juan': 'America_Argentina_San_Juan',
        'America/Argentina/San_Luis': 'America_Argentina_San_Luis',
        'America/Argentina/Tucuman': 'America_Argentina_Tucuman',
        'America/Argentina/Ushuaia': 'America_Argentina_Ushuaia',
        'America/Aruba': 'America_Aruba',
        'America/Asuncion': 'America_Asuncion',
        'America/Atikokan': 'America_Atikokan',
        'America/Atka': 'America_Atka',
        'America/Bahia': 'America_Bahia',
        'America/Bahia_Banderas': 'America_Bahia_Banderas',
        'America/Barbados': 'America_Barbados',
        'America/Belem': 'America_Belem',
        'America/Belize': 'America_Belize',
        'America/Blanc-Sablon': 'America_BlancMinusSablon',
        'America/Boa_Vista': 'America_Boa_Vista',
        'America/Bogota': 'America_Bogota',
        'America/Boise': 'America_Boise',
        'America/Buenos_Aires': 'America_Buenos_Aires',
        'America/Cambridge_Bay': 'America_Cambridge_Bay',
        'America/Campo_Grande': 'America_Campo_Grande',
        'America/Cancun': 'America_Cancun',
        'America/Caracas': 'America_Caracas',
        'America/Catamarca': 'America_Catamarca',
        'America/Cayenne': 'America_Cayenne',
        'America/Cayman': 'America_Cayman',
        'America/Chicago': 'America_Chicago',
        'America/Chihuahua': 'America_Chihuahua',
        'America/Coral_Harbour': 'America_Coral_Harbour',
        'America/Cordoba': 'America_Cordoba',
        'America/Costa_Rica': 'America_Costa_Rica',
        'America/Creston': 'America_Creston',
        'America/Cuiaba': 'America_Cuiaba',
        'America/Curacao': 'America_Curacao',
        'America/Danmarkshavn': 'America_Danmarkshavn',
        'America/Dawson': 'America_Dawson',
        'America/Dawson_Creek': 'America_Dawson_Creek',
        'America/Denver': 'America_Denver',
        'America/Detroit': 'America_Detroit',
        'America/Dominica': 'America_Dominica',
        'America/Edmonton': 'America_Edmonton',
        'America/Eirunepe': 'America_Eirunepe',
        'America/El_Salvador': 'America_El_Salvador',
        'America/Ensenada': 'America_Ensenada',
        'America/Fort_Nelson': 'America_Fort_Nelson',
        'America/Fort_Wayne': 'America_Fort_Wayne',
        'America/Fortaleza': 'America_Fortaleza',
        'America/Glace_Bay': 'America_Glace_Bay',
        'America/Godthab': 'America_Godthab',
        'America/Goose_Bay': 'America_Goose_Bay',
        'America/Grand_Turk': 'America_Grand_Turk',
        'America/Grenada': 'America_Grenada',
        'America/Guadeloupe': 'America_Guadeloupe',
        'America/Guatemala': 'America_Guatemala',
        'America/Guayaquil': 'America_Guayaquil',
        'America/Guyana': 'America_Guyana',
        'America/Halifax': 'America_Halifax',
        'America/Havana': 'America_Havana',
        'America/Hermosillo': 'America_Hermosillo',
        'America/Indiana/Indianapolis': 'America_Indiana_Indianapolis',
        'America/Indiana/Knox': 'America_Indiana_Knox',
        'America/Indiana/Marengo': 'America_Indiana_Marengo',
        'America/Indiana/Petersburg': 'America_Indiana_Petersburg',
        'America/Indiana/Tell_City': 'America_Indiana_Tell_City',
        'America/Indiana/Vevay': 'America_Indiana_Vevay',
        'America/Indiana/Vincennes': 'America_Indiana_Vincennes',
        'America/Indiana/Winamac': 'America_Indiana_Winamac',
        'America/Indianapolis': 'America_Indianapolis',
        'America/Inuvik': 'America_Inuvik',
        'America/Iqaluit': 'America_Iqaluit',
        'America/Jamaica': 'America_Jamaica',
        'America/Jujuy': 'America_Jujuy',
        'America/Juneau': 'America_Juneau',
        'America/Kentucky/Louisville': 'America_Kentucky_Louisville',
        'America/Kentucky/Monticello': 'America_Kentucky_Monticello',
        'America/Knox_IN': 'America_Knox_IN',
        'America/Kralendijk': 'America_Kralendijk',
        'America/La_Paz': 'America_La_Paz',
        'America/Lima': 'America_Lima',
        'America/Los_Angeles': 'America_Los_Angeles',
        'America/Louisville': 'America_Louisville',
        'America/Lower_Princes': 'America_Lower_Princes',
        'America/Maceio': 'America_Maceio',
        'America/Managua': 'America_Managua',
        'America/Manaus': 'America_Manaus',
        'America/Marigot': 'America_Marigot',
        'America/Martinique': 'America_Martinique',
        'America/Matamoros': 'America_Matamoros',
        'America/Mazatlan': 'America_Mazatlan',
        'America/Mendoza': 'America_Mendoza',
        'America/Menominee': 'America_Menominee',
        'America/Merida': 'America_Merida',
        'America/Metlakatla': 'America_Metlakatla',
        'America/Mexico_City': 'America_Mexico_City',
        'America/Miquelon': 'America_Miquelon',
        'America/Moncton': 'America_Moncton',
        'America/Monterrey': 'America_Monterrey',
        'America/Montevideo': 'America_Montevideo',
        'America/Montreal': 'America_Montreal',
        'America/Montserrat': 'America_Montserrat',
        'America/Nassau': 'America_Nassau',
        'America/New_York': 'America_New_York',
        'America/Nipigon': 'America_Nipigon',
        'America/Nome': 'America_Nome',
        'America/Noronha': 'America_Noronha',
        'America/North_Dakota/Beulah': 'America_North_Dakota_Beulah',
        'America/North_Dakota/Center': 'America_North_Dakota_Center',
        'America/North_Dakota/New_Salem': 'America_North_Dakota_New_Salem',
        'America/Nuuk': 'America_Nuuk',
        'America/Ojinaga': 'America_Ojinaga',
        'America/Panama': 'America_Panama',
        'America/Pangnirtung': 'America_Pangnirtung',
        'America/Paramaribo': 'America_Paramaribo',
        'America/Phoenix': 'America_Phoenix',
        'America/Port-au-Prince': 'America_PortMinusauMinusPrince',
        'America/Port_of_Spain': 'America_Port_of_Spain',
        'America/Porto_Acre': 'America_Porto_Acre',
        'America/Porto_Velho': 'America_Porto_Velho',
        'America/Puerto_Rico': 'America_Puerto_Rico',
        'America/Punta_Arenas': 'America_Punta_Arenas',
        'America/Rainy_River': 'America_Rainy_River',
        'America/Rankin_Inlet': 'America_Rankin_Inlet',
        'America/Recife': 'America_Recife',
        'America/Regina': 'America_Regina',
        'America/Resolute': 'America_Resolute',
        'America/Rio_Branco': 'America_Rio_Branco',
        'America/Rosario': 'America_Rosario',
        'America/Santa_Isabel': 'America_Santa_Isabel',
        'America/Santarem': 'America_Santarem',
        'America/Santiago': 'America_Santiago',
        'America/Santo_Domingo': 'America_Santo_Domingo',
        'America/Sao_Paulo': 'America_Sao_Paulo',
        'America/Scoresbysund': 'America_Scoresbysund',
        'America/Shiprock': 'America_Shiprock',
        'America/Sitka': 'America_Sitka',
        'America/St_Barthelemy': 'America_St_Barthelemy',
        'America/St_Johns': 'America_St_Johns',
        'America/St_Kitts': 'America_St_Kitts',
        'America/St_Lucia': 'America_St_Lucia',
        'America/St_Thomas': 'America_St_Thomas',
        'America/St_Vincent': 'America_St_Vincent',
        'America/Swift_Current': 'America_Swift_Current',
        'America/Tegucigalpa': 'America_Tegucigalpa',
        'America/Thule': 'America_Thule',
        'America/Thunder_Bay': 'America_Thunder_Bay',
        'America/Tijuana': 'America_Tijuana',
        'America/Toronto': 'America_Toronto',
        'America/Tortola': 'America_Tortola',
        'America/Vancouver': 'America_Vancouver',
        'America/Virgin': 'America_Virgin',
        'America/Whitehorse': 'America_Whitehorse',
        'America/Winnipeg': 'America_Winnipeg',
        'America/Yakutat': 'America_Yakutat',
        'America/Yellowknife': 'America_Yellowknife',
        'Antarctica/Casey': 'Antarctica_Casey',
        'Antarctica/Davis': 'Antarctica_Davis',
        'Antarctica/DumontDUrville': 'Antarctica_DumontDUrville',
        'Antarctica/Macquarie': 'Antarctica_Macquarie',
        'Antarctica/Mawson': 'Antarctica_Mawson',
        'Antarctica/McMurdo': 'Antarctica_McMurdo',
        'Antarctica/Palmer': 'Antarctica_Palmer',
        'Antarctica/Rothera': 'Antarctica_Rothera',
        'Antarctica/South_Pole': 'Antarctica_South_Pole',
        'Antarctica/Syowa': 'Antarctica_Syowa',
        'Antarctica/Troll': 'Antarctica_Troll',
        'Antarctica/Vostok': 'Antarctica_Vostok',
        'Arctic/Longyearbyen': 'Arctic_Longyearbyen',
        'Asia/Aden': 'Asia_Aden',
        'Asia/Almaty': 'Asia_Almaty',
        'Asia/Amman': 'Asia_Amman',
        'Asia/Anadyr': 'Asia_Anadyr',
        'Asia/Aqtau': 'Asia_Aqtau',
        'Asia/Aqtobe': 'Asia_Aqtobe',
        'Asia/Ashgabat': 'Asia_Ashgabat',
        'Asia/Ashkhabad': 'Asia_Ashkhabad',
        'Asia/Atyrau': 'Asia_Atyrau',
        'Asia/Baghdad': 'Asia_Baghdad',
        'Asia/Bahrain': 'Asia_Bahrain',
        'Asia/Baku': 'Asia_Baku',
        'Asia/Bangkok': 'Asia_Bangkok',
        'Asia/Barnaul': 'Asia_Barnaul',
        'Asia/Beirut': 'Asia_Beirut',
        'Asia/Bishkek': 'Asia_Bishkek',
        'Asia/Brunei': 'Asia_Brunei',
        'Asia/Calcutta': 'Asia_Calcutta',
        'Asia/Chita': 'Asia_Chita',
        'Asia/Choibalsan': 'Asia_Choibalsan',
        'Asia/Chongqing': 'Asia_Chongqing',
        'Asia/Chungking': 'Asia_Chungking',
        'Asia/Colombo': 'Asia_Colombo',
        'Asia/Dacca': 'Asia_Dacca',
        'Asia/Damascus': 'Asia_Damascus',
        'Asia/Dhaka': 'Asia_Dhaka',
        'Asia/Dili': 'Asia_Dili',
        'Asia/Dubai': 'Asia_Dubai',
        'Asia/Dushanbe': 'Asia_Dushanbe',
        'Asia/Famagusta': 'Asia_Famagusta',
        'Asia/Gaza': 'Asia_Gaza',
        'Asia/Harbin': 'Asia_Harbin',
        'Asia/Hebron': 'Asia_Hebron',
        'Asia/Ho_Chi_Minh': 'Asia_Ho_Chi_Minh',
        'Asia/Hong_Kong': 'Asia_Hong_Kong',
        'Asia/Hovd': 'Asia_Hovd',
        'Asia/Irkutsk': 'Asia_Irkutsk',
        'Asia/Istanbul': 'Asia_Istanbul',
        'Asia/Jakarta': 'Asia_Jakarta',
        'Asia/Jayapura': 'Asia_Jayapura',
        'Asia/Jerusalem': 'Asia_Jerusalem',
        'Asia/Kabul': 'Asia_Kabul',
        'Asia/Kamchatka': 'Asia_Kamchatka',
        'Asia/Karachi': 'Asia_Karachi',
        'Asia/Kashgar': 'Asia_Kashgar',
        'Asia/Kathmandu': 'Asia_Kathmandu',
        'Asia/Katmandu': 'Asia_Katmandu',
        'Asia/Khandyga': 'Asia_Khandyga',
        'Asia/Kolkata': 'Asia_Kolkata',
        'Asia/Krasnoyarsk': 'Asia_Krasnoyarsk',
        'Asia/Kuala_Lumpur': 'Asia_Kuala_Lumpur',
        'Asia/Kuching': 'Asia_Kuching',
        'Asia/Kuwait': 'Asia_Kuwait',
        'Asia/Macao': 'Asia_Macao',
        'Asia/Macau': 'Asia_Macau',
        'Asia/Magadan': 'Asia_Magadan',
        'Asia/Makassar': 'Asia_Makassar',
        'Asia/Manila': 'Asia_Manila',
        'Asia/Muscat': 'Asia_Muscat',
        'Asia/Nicosia': 'Asia_Nicosia',
        'Asia/Novokuznetsk': 'Asia_Novokuznetsk',
        'Asia/Novosibirsk': 'Asia_Novosibirsk',
        'Asia/Omsk': 'Asia_Omsk',
        'Asia/Oral': 'Asia_Oral',
        'Asia/Phnom_Penh': 'Asia_Phnom_Penh',
        'Asia/Pontianak': 'Asia_Pontianak',
        'Asia/Pyongyang': 'Asia_Pyongyang',
        'Asia/Qatar': 'Asia_Qatar',
        'Asia/Qostanay': 'Asia_Qostanay',
        'Asia/Qyzylorda': 'Asia_Qyzylorda',
        'Asia/Rangoon': 'Asia_Rangoon',
        'Asia/Riyadh': 'Asia_Riyadh',
        'Asia/Saigon': 'Asia_Saigon',
        'Asia/Sakhalin': 'Asia_Sakhalin',
        'Asia/Samarkand': 'Asia_Samarkand',
        'Asia/Seoul': 'Asia_Seoul',
        'Asia/Shanghai': 'Asia_Shanghai',
        'Asia/Singapore': 'Asia_Singapore',
        'Asia/Srednekolymsk': 'Asia_Srednekolymsk',
        'Asia/Taipei': 'Asia_Taipei',
        'Asia/Tashkent': 'Asia_Tashkent',
        'Asia/Tbilisi': 'Asia_Tbilisi',
        'Asia/Tehran': 'Asia_Tehran',
        'Asia/Tel_Aviv': 'Asia_Tel_Aviv',
        'Asia/Thimbu': 'Asia_Thimbu',
        'Asia/Thimphu': 'Asia_Thimphu',
        'Asia/Tokyo': 'Asia_Tokyo',
        'Asia/Tomsk': 'Asia_Tomsk',
        'Asia/Ujung_Pandang': 'Asia_Ujung_Pandang',
        'Asia/Ulaanbaatar': 'Asia_Ulaanbaatar',
        'Asia/Ulan_Bator': 'Asia_Ulan_Bator',
        'Asia/Urumqi': 'Asia_Urumqi',
        'Asia/Ust-Nera': 'Asia_UstMinusNera',
        'Asia/Vientiane': 'Asia_Vientiane',
        'Asia/Vladivostok': 'Asia_Vladivostok',
        'Asia/Yakutsk': 'Asia_Yakutsk',
        'Asia/Yangon': 'Asia_Yangon',
        'Asia/Yekaterinburg': 'Asia_Yekaterinburg',
        'Asia/Yerevan': 'Asia_Yerevan',
        'Atlantic/Azores': 'Atlantic_Azores',
        'Atlantic/Bermuda': 'Atlantic_Bermuda',
        'Atlantic/Canary': 'Atlantic_Canary',
        'Atlantic/Cape_Verde': 'Atlantic_Cape_Verde',
        'Atlantic/Faeroe': 'Atlantic_Faeroe',
        'Atlantic/Faroe': 'Atlantic_Faroe',
        'Atlantic/Jan_Mayen': 'Atlantic_Jan_Mayen',
        'Atlantic/Madeira': 'Atlantic_Madeira',
        'Atlantic/Reykjavik': 'Atlantic_Reykjavik',
        'Atlantic/South_Georgia': 'Atlantic_South_Georgia',
        'Atlantic/St_Helena': 'Atlantic_St_Helena',
        'Atlantic/Stanley': 'Atlantic_Stanley',
        'Australia/ACT': 'Australia_ACT',
        'Australia/Adelaide': 'Australia_Adelaide',
        'Australia/Brisbane': 'Australia_Brisbane',
        'Australia/Broken_Hill': 'Australia_Broken_Hill',
        'Australia/Canberra': 'Australia_Canberra',
        'Australia/Currie': 'Australia_Currie',
        'Australia/Darwin': 'Australia_Darwin',
        'Australia/Eucla': 'Australia_Eucla',
        'Australia/Hobart': 'Australia_Hobart',
        'Australia/LHI': 'Australia_LHI',
        'Australia/Lindeman': 'Australia_Lindeman',
        'Australia/Lord_Howe': 'Australia_Lord_Howe',
        'Australia/Melbourne': 'Australia_Melbourne',
        'Australia/NSW': 'Australia_NSW',
        'Australia/North': 'Australia_North',
        'Australia/Perth': 'Australia_Perth',
        'Australia/Queensland': 'Australia_Queensland',
        'Australia/South': 'Australia_South',
        'Australia/Sydney': 'Australia_Sydney',
        'Australia/Tasmania': 'Australia_Tasmania',
        'Australia/Victoria': 'Australia_Victoria',
        'Australia/West': 'Australia_West',
        'Australia/Yancowinna': 'Australia_Yancowinna',
        'Brazil/Acre': 'Brazil_Acre',
        'Brazil/DeNoronha': 'Brazil_DeNoronha',
        'Brazil/East': 'Brazil_East',
        'Brazil/West': 'Brazil_West',
        CET: 'CET',
        CST6CDT: 'CST6CDT',
        'Canada/Atlantic': 'Canada_Atlantic',
        'Canada/Central': 'Canada_Central',
        'Canada/Eastern': 'Canada_Eastern',
        'Canada/Mountain': 'Canada_Mountain',
        'Canada/Newfoundland': 'Canada_Newfoundland',
        'Canada/Pacific': 'Canada_Pacific',
        'Canada/Saskatchewan': 'Canada_Saskatchewan',
        'Canada/Yukon': 'Canada_Yukon',
        'Chile/Continental': 'Chile_Continental',
        'Chile/EasterIsland': 'Chile_EasterIsland',
        Cuba: 'Cuba',
        EET: 'EET',
        EST: 'EST',
        EST5EDT: 'EST5EDT',
        Egypt: 'Egypt',
        Eire: 'Eire',
        'Etc/GMT': 'Etc_GMT',
        'Etc/GMT+0': 'Etc_GMTPlus0',
        'Etc/GMT+1': 'Etc_GMTPlus1',
        'Etc/GMT+10': 'Etc_GMTPlus10',
        'Etc/GMT+11': 'Etc_GMTPlus11',
        'Etc/GMT+12': 'Etc_GMTPlus12',
        'Etc/GMT+2': 'Etc_GMTPlus2',
        'Etc/GMT+3': 'Etc_GMTPlus3',
        'Etc/GMT+4': 'Etc_GMTPlus4',
        'Etc/GMT+5': 'Etc_GMTPlus5',
        'Etc/GMT+6': 'Etc_GMTPlus6',
        'Etc/GMT+7': 'Etc_GMTPlus7',
        'Etc/GMT+8': 'Etc_GMTPlus8',
        'Etc/GMT+9': 'Etc_GMTPlus9',
        'Etc/GMT-0': 'Etc_GMTMinus0',
        'Etc/GMT-1': 'Etc_GMTMinus1',
        'Etc/GMT-10': 'Etc_GMTMinus10',
        'Etc/GMT-11': 'Etc_GMTMinus11',
        'Etc/GMT-12': 'Etc_GMTMinus12',
        'Etc/GMT-13': 'Etc_GMTMinus13',
        'Etc/GMT-14': 'Etc_GMTMinus14',
        'Etc/GMT-2': 'Etc_GMTMinus2',
        'Etc/GMT-3': 'Etc_GMTMinus3',
        'Etc/GMT-4': 'Etc_GMTMinus4',
        'Etc/GMT-5': 'Etc_GMTMinus5',
        'Etc/GMT-6': 'Etc_GMTMinus6',
        'Etc/GMT-7': 'Etc_GMTMinus7',
        'Etc/GMT-8': 'Etc_GMTMinus8',
        'Etc/GMT-9': 'Etc_GMTMinus9',
        'Etc/GMT0': 'Etc_GMT0',
        'Etc/Greenwich': 'Etc_Greenwich',
        'Etc/UCT': 'Etc_UCT',
        'Etc/UTC': 'Etc_UTC',
        'Etc/Universal': 'Etc_Universal',
        'Etc/Zulu': 'Etc_Zulu',
        'Europe/Amsterdam': 'Europe_Amsterdam',
        'Europe/Andorra': 'Europe_Andorra',
        'Europe/Astrakhan': 'Europe_Astrakhan',
        'Europe/Athens': 'Europe_Athens',
        'Europe/Belfast': 'Europe_Belfast',
        'Europe/Belgrade': 'Europe_Belgrade',
        'Europe/Berlin': 'Europe_Berlin',
        'Europe/Bratislava': 'Europe_Bratislava',
        'Europe/Brussels': 'Europe_Brussels',
        'Europe/Bucharest': 'Europe_Bucharest',
        'Europe/Budapest': 'Europe_Budapest',
        'Europe/Busingen': 'Europe_Busingen',
        'Europe/Chisinau': 'Europe_Chisinau',
        'Europe/Copenhagen': 'Europe_Copenhagen',
        'Europe/Dublin': 'Europe_Dublin',
        'Europe/Gibraltar': 'Europe_Gibraltar',
        'Europe/Guernsey': 'Europe_Guernsey',
        'Europe/Helsinki': 'Europe_Helsinki',
        'Europe/Isle_of_Man': 'Europe_Isle_of_Man',
        'Europe/Istanbul': 'Europe_Istanbul',
        'Europe/Jersey': 'Europe_Jersey',
        'Europe/Kaliningrad': 'Europe_Kaliningrad',
        'Europe/Kiev': 'Europe_Kiev',
        'Europe/Kirov': 'Europe_Kirov',
        'Europe/Lisbon': 'Europe_Lisbon',
        'Europe/Ljubljana': 'Europe_Ljubljana',
        'Europe/London': 'Europe_London',
        'Europe/Luxembourg': 'Europe_Luxembourg',
        'Europe/Madrid': 'Europe_Madrid',
        'Europe/Malta': 'Europe_Malta',
        'Europe/Mariehamn': 'Europe_Mariehamn',
        'Europe/Minsk': 'Europe_Minsk',
        'Europe/Monaco': 'Europe_Monaco',
        'Europe/Moscow': 'Europe_Moscow',
        'Europe/Nicosia': 'Europe_Nicosia',
        'Europe/Oslo': 'Europe_Oslo',
        'Europe/Paris': 'Europe_Paris',
        'Europe/Podgorica': 'Europe_Podgorica',
        'Europe/Prague': 'Europe_Prague',
        'Europe/Riga': 'Europe_Riga',
        'Europe/Rome': 'Europe_Rome',
        'Europe/Samara': 'Europe_Samara',
        'Europe/San_Marino': 'Europe_San_Marino',
        'Europe/Sarajevo': 'Europe_Sarajevo',
        'Europe/Saratov': 'Europe_Saratov',
        'Europe/Simferopol': 'Europe_Simferopol',
        'Europe/Skopje': 'Europe_Skopje',
        'Europe/Sofia': 'Europe_Sofia',
        'Europe/Stockholm': 'Europe_Stockholm',
        'Europe/Tallinn': 'Europe_Tallinn',
        'Europe/Tirane': 'Europe_Tirane',
        'Europe/Tiraspol': 'Europe_Tiraspol',
        'Europe/Ulyanovsk': 'Europe_Ulyanovsk',
        'Europe/Uzhgorod': 'Europe_Uzhgorod',
        'Europe/Vaduz': 'Europe_Vaduz',
        'Europe/Vatican': 'Europe_Vatican',
        'Europe/Vienna': 'Europe_Vienna',
        'Europe/Vilnius': 'Europe_Vilnius',
        'Europe/Volgograd': 'Europe_Volgograd',
        'Europe/Warsaw': 'Europe_Warsaw',
        'Europe/Zagreb': 'Europe_Zagreb',
        'Europe/Zaporozhye': 'Europe_Zaporozhye',
        'Europe/Zurich': 'Europe_Zurich',
        GB: 'GB',
        'GB-Eire': 'GBMinusEire',
        GMT: 'GMT',
        'GMT+0': 'GMTPlus0',
        'GMT-0': 'GMTMinus0',
        GMT0: 'GMT0',
        Greenwich: 'Greenwich',
        HST: 'HST',
        Hongkong: 'Hongkong',
        Iceland: 'Iceland',
        'Indian/Antananarivo': 'Indian_Antananarivo',
        'Indian/Chagos': 'Indian_Chagos',
        'Indian/Christmas': 'Indian_Christmas',
        'Indian/Cocos': 'Indian_Cocos',
        'Indian/Comoro': 'Indian_Comoro',
        'Indian/Kerguelen': 'Indian_Kerguelen',
        'Indian/Mahe': 'Indian_Mahe',
        'Indian/Maldives': 'Indian_Maldives',
        'Indian/Mauritius': 'Indian_Mauritius',
        'Indian/Mayotte': 'Indian_Mayotte',
        'Indian/Reunion': 'Indian_Reunion',
        Iran: 'Iran',
        Israel: 'Israel',
        Jamaica: 'Jamaica',
        Japan: 'Japan',
        Kwajalein: 'Kwajalein',
        Libya: 'Libya',
        MET: 'MET',
        MST: 'MST',
        MST7MDT: 'MST7MDT',
        'Mexico/BajaNorte': 'Mexico_BajaNorte',
        'Mexico/BajaSur': 'Mexico_BajaSur',
        'Mexico/General': 'Mexico_General',
        NZ: 'NZ',
        'NZ-CHAT': 'NZMinusCHAT',
        Navajo: 'Navajo',
        PRC: 'PRC',
        PST8PDT: 'PST8PDT',
        'Pacific/Apia': 'Pacific_Apia',
        'Pacific/Auckland': 'Pacific_Auckland',
        'Pacific/Bougainville': 'Pacific_Bougainville',
        'Pacific/Chatham': 'Pacific_Chatham',
        'Pacific/Chuuk': 'Pacific_Chuuk',
        'Pacific/Easter': 'Pacific_Easter',
        'Pacific/Efate': 'Pacific_Efate',
        'Pacific/Enderbury': 'Pacific_Enderbury',
        'Pacific/Fakaofo': 'Pacific_Fakaofo',
        'Pacific/Fiji': 'Pacific_Fiji',
        'Pacific/Funafuti': 'Pacific_Funafuti',
        'Pacific/Galapagos': 'Pacific_Galapagos',
        'Pacific/Gambier': 'Pacific_Gambier',
        'Pacific/Guadalcanal': 'Pacific_Guadalcanal',
        'Pacific/Guam': 'Pacific_Guam',
        'Pacific/Honolulu': 'Pacific_Honolulu',
        'Pacific/Johnston': 'Pacific_Johnston',
        'Pacific/Kanton': 'Pacific_Kanton',
        'Pacific/Kiritimati': 'Pacific_Kiritimati',
        'Pacific/Kosrae': 'Pacific_Kosrae',
        'Pacific/Kwajalein': 'Pacific_Kwajalein',
        'Pacific/Majuro': 'Pacific_Majuro',
        'Pacific/Marquesas': 'Pacific_Marquesas',
        'Pacific/Midway': 'Pacific_Midway',
        'Pacific/Nauru': 'Pacific_Nauru',
        'Pacific/Niue': 'Pacific_Niue',
        'Pacific/Norfolk': 'Pacific_Norfolk',
        'Pacific/Noumea': 'Pacific_Noumea',
        'Pacific/Pago_Pago': 'Pacific_Pago_Pago',
        'Pacific/Palau': 'Pacific_Palau',
        'Pacific/Pitcairn': 'Pacific_Pitcairn',
        'Pacific/Pohnpei': 'Pacific_Pohnpei',
        'Pacific/Ponape': 'Pacific_Ponape',
        'Pacific/Port_Moresby': 'Pacific_Port_Moresby',
        'Pacific/Rarotonga': 'Pacific_Rarotonga',
        'Pacific/Saipan': 'Pacific_Saipan',
        'Pacific/Samoa': 'Pacific_Samoa',
        'Pacific/Tahiti': 'Pacific_Tahiti',
        'Pacific/Tarawa': 'Pacific_Tarawa',
        'Pacific/Tongatapu': 'Pacific_Tongatapu',
        'Pacific/Truk': 'Pacific_Truk',
        'Pacific/Wake': 'Pacific_Wake',
        'Pacific/Wallis': 'Pacific_Wallis',
        'Pacific/Yap': 'Pacific_Yap',
        Poland: 'Poland',
        Portugal: 'Portugal',
        ROC: 'ROC',
        ROK: 'ROK',
        Singapore: 'Singapore',
        Turkey: 'Turkey',
        UCT: 'UCT',
        'US/Alaska': 'US_Alaska',
        'US/Aleutian': 'US_Aleutian',
        'US/Arizona': 'US_Arizona',
        'US/Central': 'US_Central',
        'US/East-Indiana': 'US_EastMinusIndiana',
        'US/Eastern': 'US_Eastern',
        'US/Hawaii': 'US_Hawaii',
        'US/Indiana-Starke': 'US_IndianaMinusStarke',
        'US/Michigan': 'US_Michigan',
        'US/Mountain': 'US_Mountain',
        'US/Pacific': 'US_Pacific',
        'US/Samoa': 'US_Samoa',
        UTC: 'UTC',
        Universal: 'Universal',
        'W-SU': 'WMinusSU',
        WET: 'WET',
        Zulu: 'Zulu',
    },
    demoMeasuringPoints: {
        all: [105, 26128],
        vibration: 105,
    },
    demoProjects: {
        vibration: 14403,
    },
    permissionLevels: {
        REFERENCE: 0,
        VIEW: 1,
        FULL_ACCESS: 2,
    },
} as const;
